import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatMenuTrigger, MAT_DIALOG_DATA } from '@angular/material';
import moment from 'moment';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { DeNghiMuaHangService } from '../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { BaoCaoChiTietDonHangBanDetailComponent } from '../../../thong-ke-bao-cao/bao-cao-chi-tiet-don-hang-ban/bao-cao-chi-tiet-don-hang-ban-detail/bao-cao-chi-tiet-don-hang-ban-detail.component';
import { YeuCauDuyetGiaService } from '../../yeu-cau-duyet-gia/yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
import { DsLishSuBanComponent } from '../ds-lich-su-ban/ds-lich-su-ban.component';
import { DsYeuCauDuyetGiaComponent } from '../ds-yeu-cau-duyet-gia/ds-yeu-cau-duyet-gia.component';
import { ConstantPurchaseOrder, DetailGiaoHang, HistoriesForecastChangeDetailParam, HistoriesForecastChangeParam, KDDatHang, KDDatHangChiTiet, ThongTinXacNhanCTModel, ThongTinXacNhanModel } from '../kd-dat-hang-model/kd-dat-hang.model';
import { KDDatHangService } from '../kd-dat-hang-service/kd-dat-hang.service';
import { ThongTinXacNhanComponent } from '../thong-tin-xac-nhan/thong-tin-xac-nhan.component';
import { ThongTinXacNhanFCComponent } from '../thong-tin-xac-nhan-fc/thong-tin-xac-nhan-fc.component';
import { FileImport } from '../../../dung-chung/__model/file-import.model';
import { Item } from '@syncfusion/ej2-angular-navigations';
import { KenhSanService } from '../../../danh-muc/kenh-san/kenh-san-service/kenh-san.service';
import { E } from '@angular/cdk/keycodes';
import { ChiTietSoLuongTonPageComponent } from '../../../chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/chi-tiet-so-luong-ton-page/chi-tiet-so-luong-ton-page.component';
import { ForecastUpdateModelComponent } from '../modal/forecast-update-modal.component';
import { DiaChiGiaoHang } from '../../../khach-hang/khach-hang-model/khach-hang.model';
import { element } from 'protractor';

@Component({
	selector: 'm-kd-dat-hang-edit',
	templateUrl: './kd-dat-hang-edit.component.html',
	styleUrls: ['../kd-dat-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})

export class KDDatHangEditComponent implements OnInit {
	CONFIG: CommonConFig;

	@ViewChildren('focusDetail') focusDetail;
	@ViewChildren('focusPYCBG') focusPYCBG;
	@ViewChildren('focusSL') focusSL;
	@ViewChildren('focus') focus;
	@ViewChildren('focusDuyetPhieuLyDo') focusDuyetPhieuLyDo;
	@ViewChildren('focusXacNhanLyDo') focusXacNhanLyDo;
	@ViewChildren('focusChotDHLyDo') focusChotDHLyDo;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	@ViewChild("fileUpload1", { static: false }) fileUpload1: ElementRef;
	@ViewChild("fileUploadImport", { static: false }) fileUploadImport: ElementRef;

	displayedColumns = [];
	availableColumns = [
		{
			stt: 0,
			name: 'checkbox',
			displayName: 'checkbox',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MAHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SL',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DONVITINH',
			displayName: 'Đơn vị tính',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'DONGIA',
			displayName: 'Đơn giá',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONGDAGIAO',
			displayName: 'Số lượng đã giao',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONGTONKHO',
			displayName: 'Số lượng tồn kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'NGAYYCGIAOHANG',
			displayName: 'Ngày YC giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'THANHTIEN',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'THANHTIENQUYDOI',
			displayName: 'Thành tiền quy đổi',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'PHANTRAMTHUE',
			displayName: '% Thuế GTGT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'THUEGTGT',
			displayName: 'Thuế GTGT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'DIACHIGIAOHANG',
			displayName: 'Địa chỉ giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'GHICHU',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'THUOCFC',
			displayName: 'Thuộc forecast',
			alwaysChecked: false,
			isShow: true
		}
	];

	displayedColumnsDetail = [];
	availableColumnsDetail = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MAHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SL',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DONVITINH',
			displayName: 'Đơn vị tính',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'DONGIA',
			displayName: 'Đơn giá',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONGDAGIAO',
			displayName: 'Số lượng đã giao',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONGTONKHO',
			displayName: 'Số lượng tồn kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'NGAYYCGIAOHANG',
			displayName: 'Ngày YC giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'THANHTIEN',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'THANHTIENQUYDOI',
			displayName: 'Thành tiền quy đổi',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'PHANTRAMTHUE',
			displayName: '% Thuế GTGT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'THUEGTGT',
			displayName: 'Thuế GTGT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'DIACHIGIAOHANG',
			displayName: 'Địa chỉ giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'GHICHU',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'THUOCFC',
			displayName: 'Thuộc forecast',
			alwaysChecked: false,
			isShow: true
		}
	];

	displayedColumnsf = [];
	availableColumnsf = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MAHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SL',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DONVITINH',
			displayName: 'Đơn vị tính',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONGDAGIAO',
			displayName: 'Số lượng đã giao',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'NGAYYCCOANGTU',
			displayName: 'Ngày YC có hàng: từ',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'NGAYYCCOANGDEN',
			displayName: 'Ngày YC có hàng: đến',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 9,
			name: 'GHICHU',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		}
	];

	extendsColumn = [
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];

	extendsColumn2 = [
		{
			stt: 99,
			name: 'ACTIONS2',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];
	extendsColumnf = [
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];

	extendsColumn2f = [
		{
			stt: 99,
			name: 'ACTIONS2',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];
	extendsColumn3f = [
		{
			stt: 0,
			name: 'select',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];

	extendsColumnDetail = [
		{
			stt: 100,
			name: 'TRANGTHAIXACNHAN',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
	];

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
	//selection = new SelectionModel<KDDatHangChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* End comment columns mat-table -------------------------------------*/
	currency_unit = [];
	history = [];
	/* ------------------------------------------------------------------ */
	listYCDG: any[] = [];
	listHH: any[] = [];
	selectYCDG: string = '';
	filteredYCDG: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filteredHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	YCDGFilterCtrl: string = '';
	HHFilterCtrl: string = '';
	haveElementYCDG: boolean = false;

	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;

	listListKH: any[] = [];
	selectListKH: string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;

	listChannel: any[] = [];
	selectListChannel: string = '';
	filteredListChannel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListChannelFilterCtrl: string = '';
	haveElementListChannel: boolean = false;

	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = '0';
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	FormPhieu: FormGroup;
	FormPhieuInit: FormGroup;
	FormThemTungMH: FormGroup;
	FormTongTien: FormGroup;
	FormTPDuyet: FormGroup;
	FormKHXacNhan: FormGroup;
	FormChotDonHang: FormGroup;
	FormDongDonHang: FormGroup;
	FormNVKDConfirm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KDDatHangItem: KDDatHang;
	listChiTietHangVe: KDDatHangChiTiet[] = [];
	tmpChiTietKDDatHang: any[] = [];
	tmpChiTietKDDatHangf: any[] = [];
	compareChiTietHangVe: KDDatHangChiTiet[] = [];
	listThuocForecast = [];

	TinhTrang = [
		{
			Code: 'KDDH_DANGSOANTHAO',
			Name: 'Đang soạn thảo'
		},
		{
			Code: 'KDDH_CHODUYET',
			Name: 'Chờ duyệt'
		},
		{
			Code: 'KDDH_KHONGDUYET',
			Name: 'Không duyệt'
		},
		{
			Code: 'KDDH_CHOKHHXACNHAN',
			Name: 'Chờ K.Hoạch xác nhận'
		},
		{
			Code: 'KDDH_TUCHOI',
			Name: 'Từ chối'
		},
		{
			Code: 'KDDH_CHOCHOTHANG',
			Name: 'Chờ chốt đơn hàng'
		},
		{
			Code: 'KDDH_HUYCHOTHANG',
			Name: 'Đã hủy'
		},
		{
			Code: 'KDDH_HOANTAT',
			Name: 'Hoàn tất'
		},
		{
			Code: 'KDDH_DAHUY',
			Name: 'Đã hủy'
		},
		{
			Code: 'KDDH_XOA',
			Name: 'Đã xóa'
		},
		{
			Code: 'KDDH_DANGTHUCHIEN',
			Name: 'Đang thực hiện'
		},
		{
			Code: 'KDDH_CHONVKEHOACH',
			Name: 'Chờ NV.Kế hoạch xác nhận'
		},
		{
			Code: 'KDDH_NVKH_KHONGXACNHAN',
			Name: 'NV.KH không xác nhận'
		},
	];

	loaiPhieu = [
		{
			value: '-1',
			name: 'Chọn loại phiếu'
		},
		{
			value: '0',
			name: 'Đặt hàng khách hàng'
		},
		{
			value: '1',
			name: 'Forecast'
		}
	];

	them_moi: boolean = false;
	chinh_sua: boolean = false;
	chi_tiet: boolean = false;
	duyet_phieu: boolean = false;
	xac_nhan: boolean = false;
	chot_don_hang: boolean = false;
	dong_don_hang: boolean = false;
	thay_doi_forecast: boolean = false;

	vung_1: boolean = false;
	vung_2: boolean = false;
	vung_3: boolean = false;
	vung_4: boolean = false;
	vung_5: boolean = false;
	vung_6: boolean = false;
	vung_7: boolean = false;
	open_thongtinxacnhan: boolean = false;

	/* ROLE */
	SHOWPRICE = '01016';
	LIST_ROLES_USER: [] = [];
	HIDE_PRICE = new BehaviorSubject<boolean>(false);

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* Action form */
	__ACTION = 1;
	__CREATE = 1;
	__EDIT = 2;
	/* Parameter liên quan đến giá trị tiền */
	__TIENCHUATHUE = 0;
	__THUE = 0;
	__TONGTIEN = 0;

	_DAT_HANG_KHACH_HANG = '0';
	_FORECAST = '1';
	dataHH = 0;

	minDate = new Date();
	checkAll: boolean = false;
	currentDate: any;
	__LoaiPhieu: any;

	// .. Bằng chứng giá
	priceEvidenceFiles: FileImport[] = [];
	PriceEvidenceFilesForm: FormGroup;
	displayedColumnsFile = ["STT", "File", "Size", "Type"];
	priceEvidenceFilesTmp: FileImport[] = [];
	listFileName: string[] = [];

	listAdressOfCustomerSelected = [];
	listConfirmSelected = [];
	/* ------------------------------------------------------------------ */

	titleAccept: string = "Thông tin TP duyệt";
	subTitleAccept: string = "duyệt";
	titlePlanEmployeeAccept: string = "Thông tin NV.Kế hoạch xác nhận";
	subTitlePlanEmployeeAccept: string = "xác nhận";
	titleConfirm: string = "Thông tin Kế hoạch xác nhận";
	subTitleConfirm: string = "xác nhận";

	loaiChietKhau = ConstantPurchaseOrder.DROPDOWN_LOAICHIETKHAU;
	isModelB2C: boolean = false;
	isWaitToPlanningEmployee: boolean = false;

	loadingDownloadTemplate = new BehaviorSubject<boolean>(false);
	loadingImportFile = new BehaviorSubject<boolean>(false);

	constructor(
		public dialogRef: MatDialogRef<KDDatHangEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KDDatHangService: KDDatHangService,
		public dialog: MatDialog,
		private FormPhieuFB: FormBuilder,
		private FormThemTungMHFB: FormBuilder,
		private FormTongTienFB: FormBuilder,
		private FormTPDuyetFB: FormBuilder,
		private FormKHXacNhanFB: FormBuilder,
		private FormChotDonHangFB: FormBuilder,
		private FormDongDonHangFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private dungChung: DungChungService,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private donHangBanService: KDDatHangService,
		private el: ElementRef,
		private YeuCauDuyetGiaService: YeuCauDuyetGiaService,
		private PriceEvidenceFilesFormFB: FormBuilder,
		private categoryChannelService: KenhSanService,
		private FormNVKDConfirmFB: FormBuilder
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
		this.dialogRef.disableClose = true;
		this.isModelB2C = this.data.model == ConstantPurchaseOrder.CODE_B2C;
	}

	/** LOAD DATA */
	async ngOnInit() {
		this.currentDate = new Date();
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.them_moi = this.data.them_moi ? this.data.them_moi : false;
		this.chinh_sua = this.data.chinh_sua ? this.data.chinh_sua : false;
		this.chi_tiet = this.data.chi_tiet ? this.data.chi_tiet : false;
		this.duyet_phieu = this.data.duyet_phieu ? this.data.duyet_phieu : false;
		this.xac_nhan = this.data.xac_nhan ? this.data.xac_nhan : false;
		this.chot_don_hang = this.data.chot_don_hang ? this.data.chot_don_hang : false;
		this.dong_don_hang = this.data.dong_don_hang ? this.data.dong_don_hang : false;
		this.thay_doi_forecast = this.data.thay_doi_forecast ? this.data.thay_doi_forecast : false;
		this.__LoaiPhieu = this.data.data.LoaiPhieu;

		/*Get data from list when open dialog */
		const data = this.data.data;
		this.KDDatHangItem = new KDDatHang;
		this.KDDatHangItem.clear();
		this.KDDatHangItem.Type = data.LoaiPhieu == undefined ? data.Type : data.LoaiPhieu;
		this.KDDatHangItem.BusinessModel = this.data.model.toUpperCase();

		/*Load all dropdown and create form */
		this.YCDG();
		this.ListHH();
		this.ListKH();
		this.getCurrentUnit();

		this.createForm();
		this.FormThemTungMH.get('MAHH').valueChanges.subscribe(newValue => {
			this.filterId_HH(newValue);
		})

		const __id = this.data.data.IdDH;
		if (__id == 0) {
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
			this.FormPhieu.controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);

			this.FormPhieu.controls['LOAIPHIEU'].setValue('' + this.__LoaiPhieu);
			this.createBillNumber().then(r => { this.FormPhieu.controls['SOPHIEU'].setValue(r); });
			this.FormPhieu.controls['TRANGTHAI'].setValue(this.TinhTrang[0].Name);
			this.FormTongTien.controls['TONGTIENCHUATHUE'].setValue(this.f_currency_VND(this.formatNumber('0')));
			this.FormTongTien.controls['TONGTIEN'].setValue(this.f_currency_VND(this.formatNumber('0')));
			this.tmpChiTietKDDatHang = [];

			if (this.data.listData) {
				const IsUpdateData = this.them_moi || this.chinh_sua;
				const CustomerCode = IsUpdateData ? '' + this.KDDatHangItem.IdKH : this.KDDatHangItem.MaKH;
				this.KDDatHangItem.copy(this.data.data);
				this.FormPhieu.controls['MAKH'].setValue(CustomerCode);
				this.FormPhieu.controls['TENKH'].setValue(this.KDDatHangItem.TenKH);

				this.data.listData.forEach(x => {
					let tmp = new KDDatHangChiTiet();
					tmp.clear();
					tmp.YeuCauDuyetGiaCt = x.IdCt;
					tmp.SoPhieuYCDG = x.SoPhieuYCDG;
					tmp.IdHH = x.IdHH;
					tmp.MaHH = x.MaHH;
					tmp.TenHH = x.TenHH;
					tmp.QuyCach = x.QuyCach;
					tmp.DVT = x.DVT;
					tmp.TenDVT = x.TenDVT;
					tmp.DonGia = x.DonGia;
					tmp.KhoiLuong = x.SoLuong;
					tmp.oldKhoiLuong = x.SoLuong;
					tmp.NgayGiaoHang = moment(x.NgayYCGH).format("YYYY-MM-DD").toString();
					tmp.PhanTramThueVAT = x.PhanTramThueVAT;
					tmp.TienThueVAT = 0;
					tmp.SoLuongDaGiao = 0;
					tmp.ThanhTien = tmp.DonGia * tmp.KhoiLuong;
					tmp.ThanhTienQuyDoi = tmp.DonGia * tmp.KhoiLuong * this.customNumberFormat(this.FormPhieu.controls['TYGIA'].value.toString());
					tmp.TonKho = x.TonKho;

					this.KDDatHangService.getTonKhoHangHoa_ById(+tmp.IdHH).subscribe(res => {
						if (res && res.status == 1) {
							tmp.SLCoPO = res.data.SLCoPO;
							tmp.SLTuDo = res.data.SLTuDo;
						}
					})

					if (this.checkAll) {
						tmp.ThuocForecast = true;
					}
					const current_loaitien = this.getTienTeCurrent();

					if (current_loaitien != null) {
						tmp.TienTe_Id = current_loaitien.Id;
						tmp.TienTe_Ten = current_loaitien.Ten;
					}

					// Kiem tra da ton tai tu truoc chua
					let t = false;

					let i = this.tmpChiTietKDDatHang.findIndex(x => x.IdHH == tmp.IdHH && x.SoPhieuYCDG == tmp.SoPhieuYCDG);
					if (i == -1) this.tmpChiTietKDDatHang.push(tmp);
					else {
						this.tmpChiTietKDDatHang[i].KhoiLuong += tmp.KhoiLuong;
						this.tmpChiTietKDDatHang[i].GhiChu = (this.tmpChiTietKDDatHang[i].GhiChu ? this.tmpChiTietKDDatHang[i].GhiChu + ', ' : '') + tmp.GhiChu ? tmp.GhiChu : '';
					}
				})
				let it = this.tmpChiTietKDDatHang;
				this.tmpChiTietKDDatHang = [];
				this.tmpChiTietKDDatHang = [...it];
				this.updateThanhTienQuyDoi();
			}

			if (this.data.data.Cts && this.data.data.Cts.length) {
				this.KDDatHangItem.copy(this.data.data);

				const data = this.KDDatHangItem;
				const form = this.FormPhieu.controls;
				const isForecast = this.__LoaiPhieu == ConstantPurchaseOrder.OPTION_FORECAST;
				const IsUpdateData = this.them_moi || this.chinh_sua;
				const CustomerCode = IsUpdateData ? '' + data.IdKH : data.MaKH;

				form['MAKH'].setValue(CustomerCode);
				form['TENKH'].setValue(data.TenKH);
				form['GHICHU'].setValue(data.GhiChu);
				if (this.checkControlExists('KENHSAN'))
					form['KENHSAN'].setValue(data.ChannelOrPlatform);
				if (this.checkControlExists('CUSTOMER_PURECHASE_ORDER'))
					form['CUSTOMER_PURECHASE_ORDER'].setValue(data.CustomerPurchaseOrder);

				let details = [];
				this.data.data.Cts.forEach(e => {
					let detail = new KDDatHangChiTiet();
					detail.filteredListForecast.next([]);
					detail.clear();
					detail.copy(e);
					detail.IdCt = 0;
					details.push(detail);
					if (detail.ThuocForecast) {
						this.getListForecast(detail);
					}
				})

				if (isForecast) {
					this.tmpChiTietKDDatHangf = [];
					this.tmpChiTietKDDatHangf = [...details];
				} else {
					form['DONVI'].setValue(data.Cts[0].TienTe_Id.toString());
					this.FormPhieu.controls['TYGIA'].setValue(this.f_currency_VND(this.formatNumber(data.Cts[0].TyGia.toString())));
					this.tmpChiTietKDDatHang = [];
					this.tmpChiTietKDDatHang = [...details];
				}

				this.updateThanhTienQuyDoi();
			}
		}
		else {
     	let res = await this.KDDatHangService.detailOrder(__id).toPromise();
			if (res && res.status === 1) {
				this.KDDatHangItem = res.data;
				this.__LoaiPhieu = this.KDDatHangItem.Type == 1 ? 0 : 1;
				this.isModelB2C = this.KDDatHangItem.BusinessModel == ConstantPurchaseOrder.CODE_B2C;
				this.createForm();
				this.anHienTheoThaoTac();
				this.lichSuThaoTac(__id, this.FormPhieu.controls['LOAIPHIEU'].value);
				this.isWaitToPlanningEmployee = this.KDDatHangItem.TrangThai_Code == ConstantPurchaseOrder.WAIT_TO_PLANNING_EMPLOYEE;

        if (this.chi_tiet && this.atLeastOneItemCanUpdateForForecast()) {
          this.tmpChiTietKDDatHang.forEach(item => {
            if (item.ThuocForecast) {
              this.getListForecast(item);
            }
          });
        }
        this.changeDetectView();
			}
			else {
				this.layoutUtilsService.showErorr("Lỗi lấy thông tin chi tiết phiếu");
			}
		}

		// Set chức năng button
		this.HIDE_PRICE.next(this.anHienGiaTien(this.SHOWPRICE));

		if (this.thay_doi_forecast) {
			this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
		}
		if (this.them_moi || this.chinh_sua) {
			this.extendsColumn.forEach(element => {
				this.availableColumns.splice(this.availableColumns.length, 0, element);
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);

			this.extendsColumnf.forEach(element => {
				this.availableColumnsf.splice(this.availableColumnsf.length, 0, element);
			});
			this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
		}
		if (this.xac_nhan || this.chot_don_hang || this.dong_don_hang || this.chi_tiet) {
			this.extendsColumn2.forEach(element => {
				this.availableColumns.splice(this.availableColumns.length, 0, element);
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);

			this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);

			this.extendsColumnDetail.forEach(element => {
				this.availableColumns.splice(this.availableColumns.length, 0, element);
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);

      if (this.chi_tiet) {
        const position = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.position;
        const columns = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.columns;
        const positionExtendDetail = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.positionExtendDetail;
        this.availableColumns.splice(position, 0, columns);
        this.availableColumnsDetail.splice(positionExtendDetail, 0, columns);

        this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
      }
		}

		this.extendPOOfCustomerColumnInList();
		this.extendColumnIfChangeForecast();

		this.anHienTheoThaoTac();
		this.showColumnsInTable();
		this.applySelectedColumns();

		this.showColumnsInTablef();
		this.applySelectedColumnsf();

		if (this.chinh_sua || this.them_moi)
			this.displayedColumnsFile.push("ThaoTac");

   	this.changeDetectView();
	}

	ngAfterViewInit() {
		this.changeDetectView();
	}

	createForm() {
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		var item: KDDatHang = new KDDatHang();
		item.clear();
		item.copy(this.KDDatHangItem);
		const TYPE = item.Type.toString();
		const NOT_FC_B2C: boolean = !(TYPE == ConstantPurchaseOrder.OPTION_FORECAST && this.isModelB2C);
		const NOT_PO_B2C: boolean = !(TYPE == ConstantPurchaseOrder.OPTION_PURCHASEORDER && this.isModelB2C);
		const IsUpdate = this.them_moi || this.chinh_sua;
		const CustomerCode = IsUpdate ? item.IdKH.toString() : item.MaKH;

		this.FormPhieu = this.FormPhieuFB.group({
			SOPHIEU: [item.SoPhieu, Validators.required],
			NGAYLAPPHIEU: [item.NgayLapPhieu ? item.NgayLapPhieu : new Date(), Validators.required],
			NGUOILAPPHIEU: [item.TenNguoiLapPhieu, Validators.required],
			TRANGTHAI: [item.TrangThai_Desc, Validators.required],
			LOAIPHIEU: [item.Type.toString(), Validators.required],
			MAKH: [(item.IdKH > 0 || item.MaKH) ? CustomerCode : ""],
			TENKH: [item.TenKH],
			DONVI: ['', Validators.required],
			TYGIA: [this.f_currency_VND(this.formatNumber('1')), Validators.required],
			GHICHU: [item.GhiChu],
			LOAICHIETKHAU: [item.LoaiChietKhau],
			GIATRICHIETKHAU: [item.GiaTriChietKhau]
		});

		if (NOT_FC_B2C) {
			this.FormPhieu.controls['MAKH'].setValidators([Validators.required]);
			this.FormPhieu.controls['MAKH'].updateValueAndValidity();
		} else {
			this.getListChannel();
			this.FormPhieu.controls['MAKH'].clearValidators();
			this.FormPhieu.controls['MAKH'].updateValueAndValidity();
			this.FormPhieu.addControl('KENHSAN', new FormControl(item.ChannelOrPlatform));
		}

		if (NOT_PO_B2C) {
			this.FormPhieu.addControl(
				'CUSTOMER_PURECHASE_ORDER',
				new FormControl(item.CustomerPurchaseOrder)
			);
		}

		this.FormThemTungMH = this.FormThemTungMHFB.group({
			MAHH: ['', Validators.required],
			TENHH: [''],
			QUYCACH: [''],
			DVT: [''],
			SOLUONG: ['0,00', [Validators.required, Validators.min(1)]],
			NGAYYCCHTU: [new Date(), Validators.required],
			NGAYYCCHDEN: [new Date(), Validators.required],
			GHICHU: [''],
			// SOPHIEUYCDG: ['', Validators.required],
		});

		this.PriceEvidenceFilesForm = this.PriceEvidenceFilesFormFB.group({
			FILENAME: ["", Validators.required]
		});

		this.FormTongTien = this.FormTongTienFB.group({
			TONGTIENCHUATHUE: [this.f_currency_VND(this.formatNumber(item.TongTienChuaThue.toString())), Validators.required],
			THUE: [this.f_currency_VND(this.formatNumber((item.TongTien - item.TongTienChuaThue).toString())), Validators.required],
			TONGTIEN: [this.f_currency_VND(this.formatNumber(item.TongTien.toString())), Validators.required]
		});

		if (this.duyet_phieu || this.chi_tiet || this.xac_nhan || this.chot_don_hang || this.dong_don_hang) {
			this.FormTPDuyet = this.FormTPDuyetFB.group({
				NGAYDUYET: [item.TPDuyet_NgayDuyet ? item.TPDuyet_NgayDuyet : this.duyet_phieu ? new Date() : ''],
				NGUOIDUYET: [item.TPDuyet_Ten ? item.TPDuyet_Ten : this.duyet_phieu ? tenNguoiLap : ''],
				LYDO: [item.TPDuyet_LyDo]
			});

			this.FormNVKDConfirm = this.FormNVKDConfirmFB.group({
				NGAYDUYET: [item.PlanEmployeeConfirmDate ? item.PlanEmployeeConfirmDate : this.duyet_phieu ? new Date() : ''],
				NGUOIDUYET: [item.PlanEmployeeConfirmName ? item.PlanEmployeeConfirmName : this.duyet_phieu ? tenNguoiLap : ''],
				LYDO: [item.PlanEmployeeConfirmReason]
			});
		}

		if (this.xac_nhan || this.chi_tiet || this.chot_don_hang || this.dong_don_hang) {
			this.FormKHXacNhan = this.FormKHXacNhanFB.group({
				NGAYDUYET: [item.KHDuyet_NgayDuyet ? item.KHDuyet_NgayDuyet : this.xac_nhan ? new Date() : ''],
				NGUOIDUYET: [item.KHDuyet_Ten ? item.KHDuyet_Ten : this.xac_nhan ? tenNguoiLap : ''],
				LYDO: [item.KHDuyet_LyDo]
			});
		}

		if (this.chot_don_hang || this.chi_tiet || this.dong_don_hang) {
			this.FormChotDonHang = this.FormChotDonHangFB.group({
				NGAYDUYET: [item.NguoiChotDon_NgayDuyet ? item.NguoiChotDon_NgayDuyet : this.chot_don_hang ? new Date() : ''],
				NGUOIDUYET: [item.NguoiChotDon_Ten ? item.NguoiChotDon_Ten : this.chot_don_hang ? tenNguoiLap : ''],
				LYDO: [item.NguoiChotDon_LyDo]
			});
		}

		if (this.chi_tiet || this.dong_don_hang) {
			this.FormDongDonHang = this.FormDongDonHangFB.group({
				LYDO: [item.DongDon_LyDo, Validators.required]
			});
		}

		this.FormPhieu.controls["SOPHIEU"].disable();
		this.FormPhieu.controls["NGUOILAPPHIEU"].disable();
		this.FormPhieu.controls["NGAYLAPPHIEU"].disable();
		this.FormPhieu.controls["TRANGTHAI"].disable();
		this.FormPhieu.controls["TENKH"].disable();
		this.FormThemTungMH.controls["TENHH"].disable();
		this.FormThemTungMH.controls["QUYCACH"].disable();
		this.FormThemTungMH.controls["DVT"].disable();
		this.FormTongTien.controls["TONGTIENCHUATHUE"].disable();
		this.FormTongTien.controls["TONGTIEN"].disable();
		this.FormTongTien.controls["THUE"].disable();
		this.FormPhieu.controls["LOAICHIETKHAU"].disable();
		this.FormPhieu.controls["GIATRICHIETKHAU"].disable();

		if (this.them_moi || this.chinh_sua) {
			this.FormPhieu.controls["LOAICHIETKHAU"].enable();
			this.FormPhieu.controls["GIATRICHIETKHAU"].enable();
			//if (NOT_FC_B2C)
			//this.FormPhieu.controls["KENHSAN"].enable();
		}

		if (this.duyet_phieu) {
			this.FormTPDuyet.controls["NGAYDUYET"].disable();
			this.FormTPDuyet.controls["NGUOIDUYET"].disable();
			this.FormNVKDConfirm.controls["NGAYDUYET"].disable();
			this.FormNVKDConfirm.controls["NGUOIDUYET"].disable();
		}
		if (this.xac_nhan) {
			this.FormKHXacNhan.controls["NGAYDUYET"].disable();
			this.FormKHXacNhan.controls["NGUOIDUYET"].disable();
		}
		if (this.chot_don_hang) {
			this.FormChotDonHang.controls["NGAYDUYET"].disable();
			this.FormChotDonHang.controls["NGUOIDUYET"].disable();
		}

		if (item.Cts.length > 0 && item.Type.toString() == ConstantPurchaseOrder.OPTION_PURCHASEORDER) {
			let TyGia = item.Cts[0].TyGia;
			this.FormPhieu.controls['DONVI'].setValue(item.Cts[0].TienTe_Id.toString());
			this.FormPhieu.controls['TYGIA'].setValue(this.f_currency_VND(this.formatNumber(TyGia.toString())));
		}

		if (item.Type == 0) {
			for (var i = 0; i < item.Cts.length; i++) {
				let tmpElement = new KDDatHangChiTiet();
				var listDetail = [];
				tmpElement.clear();
				tmpElement.copy(item.Cts[i]);
				if (item.Cts[i].ListDetailGiaoHang && item.Cts[i].ListDetailGiaoHang.length > 0) {
					for (var j = 0; j < item.Cts[i].ListDetailGiaoHang.length; j++) {
						var detail = { ...item.Cts[i].ListDetailGiaoHang[j] };
						listDetail.push(detail);
					}
				}
				tmpElement.ListDetailGiaoHang = [...listDetail];
				this.tmpChiTietKDDatHang.push(tmpElement);
			}
			this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
			this.checkAllThuocForecast();
			this.updateThanhTienQuyDoi();
		}
		else {
			for (var i = 0; i < item.Cts.length; i++) {
				let tmpElement = new KDDatHangChiTiet();
				tmpElement.clear();
				tmpElement.copy(item.Cts[i]);
				if (this.thay_doi_forecast)
					tmpElement.QuantityToBeConfirmed = null;
				this.tmpChiTietKDDatHangf.push(tmpElement);
			}
			this.tmpChiTietKDDatHangf = [...this.tmpChiTietKDDatHangf];
		}

		// .. Init Form
		this.FormPhieuInit = Object.assign({}, this.FormPhieu);

		// .. Set data bằng chứng file
		if (item.PriceEvidenceFiles.length > 0) {
			this.priceEvidenceFiles = item.PriceEvidenceFiles;
			this.priceEvidenceFiles = [...this.priceEvidenceFiles];
		}

		// Set tên tab
		if (this.isForecastB2C()) {
			this.titleAccept = "Thông tin TP xác nhận";
			this.subTitleAccept = "xác nhận";
			this.titleConfirm = "Thông tin Giám đốc Khối Kinh doanh duyệt";
			this.subTitleConfirm = "duyệt";
		}
	}

	getTitle(): string {
		var title = ` ĐƠN HÀNG BÁN ` + (this.isModelB2C ? this.data.model : "");
		if (this.vung_4) title = " FORECAST";
		if (this.them_moi) return 'THÊM MỚI' + title;
		if (this.chinh_sua) return 'CHỈNH SỬA' + title;
		if (this.chi_tiet) return 'CHI TIẾT' + title;
		if (this.duyet_phieu) return (this.isWaitToPlanningEmployee ? this.subTitlePlanEmployeeAccept : this.subTitleAccept).toUpperCase() + title;
		if (this.xac_nhan) return this.subTitleConfirm.toUpperCase() + title;
		if (this.chot_don_hang) return 'CHỐT ĐƠN HÀNG' + title;
		if (this.dong_don_hang) return 'ĐÓNG' + title;
		if (this.thay_doi_forecast) return 'THAY ĐỔI FORECAST';
		return 'THÊM MỚI' + title;
	}

	getSoPhieu() {
		return this.KDDatHangItem.SoPhieu;
	}

	async lichSuThaoTac(__id, type) {
		let res = await this.KDDatHangService.lichSuThongTinXacNhan(__id).toPromise();
		if (res && res.status === 1) {
			this.history = res.data;

			if (type == 0) {
				this.tmpChiTietKDDatHang.forEach(x => {
					var idDetailsXNGH = x.ListDetailGiaoHang.map(x => x.Id.toString());
					var sumDetailsXNGH = x.ListDetailGiaoHang.length;
					var sumDetailsXNGHValid = this.history.filter(a => a && a.Id == x.IdDH && a.IdCt == x.IdCt && a.isDongYYCGH && idDetailsXNGH.includes(a.IdXNGH));
					x.isDongYYCGH = sumDetailsXNGH == sumDetailsXNGHValid.length && sumDetailsXNGHValid.length > 0;
				})
			}
			else {
				this.tmpChiTietKDDatHangf.forEach(x => {
					let index = this.history.findIndex(a => a && a.Id == x.IdDH && a.IdCt == x.IdCt);
					if (index > -1) {
						x.isDongYYCGH = this.history[index].isDongYYCGH;
						//x.isHoanTatKHGHMoi = this.history[index].isHoanTatKHGHMoi;
					}
				})
			}
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetectView();
	}

	async getCurrentUnit() {
		let resCurrency = await this.KDDatHangService.getConfigDefaultCurrency().toPromise();
		if (resCurrency && resCurrency.status === 1) {
			let idDefaultCurrency = Number(resCurrency.data);
			let res = await this.dungChung.getDSTienTe().toPromise();
			if (res && res.status === 1) {
				this.currency_unit = res.data;
				if (this.currency_unit.length > 0 && this.KDDatHangItem.IdDH == 0) {
					let indexVND = this.currency_unit.findIndex(x => +x.Id == idDefaultCurrency);
					if (indexVND > -1)
						this.FormPhieu.controls['DONVI'].setValue(this.currency_unit[indexVND].Id.toString());
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
			// .. Lấy form lúc đầu
			this.FormPhieuInit = Object.assign({}, this.FormPhieu);
			this.changeDetectView();
		}
	}

	deleteItem(item: any) {
		let index = this.tmpChiTietKDDatHang.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKDDatHang.splice(index, 1);
		}
		let ToTalChuaThue = 0;
		let ToTal = 0;
		this.updateThanhTienQuyDoi();
		this.checkAllThuocForecast();
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.changeDetectView();
	}
	deleteItemHH(item: any) {
		let index = this.tmpChiTietKDDatHangf.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKDDatHangf.splice(index, 1);
		}
		this.tmpChiTietKDDatHangf = [...this.tmpChiTietKDDatHangf];
		this.changeDetectView();
	}

	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumns = _applySelectedColumns;
	}
	showColumnsInTablef() {

		for (let i = 0; i < this.availableColumnsf.length; i++) {
			if (this.availableColumnsf[i].isShow == false) {
				this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			}
		}
	}
	findIndexColumnf(column: string) {
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			if (this.availableColumnsf[i].name == column)
				return i;
		}
	}
	dragStartedf(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumnf(column);
	}
	dropListDroppedf(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumnsf, this.previousIndex, this.findIndexColumnf(column));
			this.applySelectedColumnsf();
		}
	}
	applySelectedColumnsf() {
		let _selectedColumns = this.selectedColumnsf.selected;
		this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumnsf[i].name == _selectedColumns[j].name) {
					this.selectedColumnsf.toggle(this.availableColumnsf[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumnsf.selected.forEach(col => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumnsf = _applySelectedColumns;

	}
	/*---------------------------------------------------------------------------------------- */


	/*---------------------------------------------------------------------------------------- */
	findCodeKH() {
		if (!this.FormPhieu) return "";
		const form = this.FormPhieu.controls;
		const selectedCustomerCode = form['MAKH'].value && form['MAKH'].value > 0 && this.listListKH.length > 0;

		return selectedCustomerCode ? this.listListKH.find(x => x.Id_KH == +form['MAKH'].value).MaKH : "";
	}

	async YCDG() {
		let res = await this.KDDatHangService.dropdown().toPromise();
		if (res && res.status == 1) {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listYCDG = res.data;
				if (this.isPurchaseOrderForm()) {
					for (var i = 0; i < this.listYCDG.length; i++) {
						if (new Date(this.listYCDG[i].DateTimeNow) > new Date(this.listYCDG[i].NgayYCGH)) {
							this.listYCDG[i].NgayYCGH = moment(this.listYCDG[i].DateTimeNow).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
						}
					}
				}

				this.filteredYCDG.next(this.listYCDG.slice());
				this.changeDetectView();
			};
		} else {
			//
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	filterYCDG() {
		if (!this.listYCDG) {
			return;
		}
		// get the search keyword
		let search = this.YCDGFilterCtrl;
		if (!search) {
			this.filteredYCDG.next(this.listYCDG.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredYCDG.next(
			this.listYCDG.filter(ts =>
				ts.SoPhieuYCDG.toLowerCase().indexOf(search) > -1
				|| ts.MaHH.toLowerCase().indexOf(search) > -1
				|| ts.TenHH.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetectView();
	}

	async ListHH() {
		let res = await this.KDDatHangService.ListHH().toPromise();
		if (res && res.status == 1) {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listHH = res.data;
				this.filteredHH.next(this.listHH.slice());
				this.changeDetectView();
			};
		} else {
			//
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	filterHH() {

		if (!this.listHH) {
			return;
		}
		// get the search keyword
		let search = this.HHFilterCtrl;
		if (!search) {
			this.filteredHH.next(this.listHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredHH.next(
			this.listHH.filter(ts =>
				(ts.MaHH ? ts.MaHH.toLowerCase().indexOf(search) > -1 : false)
				|| (ts.TenHH ? ts.TenHH.toLowerCase().indexOf(search) > -1 : false)
			)
		);
		this.changeDetectView();
	}
	/*---------------------------------------------------------------------------------------- */

	changeValueOfForm(controlName: string, event: any) {

		if (this.ValidateChangeNumberForm(event)) {

			let tmpValue = this.FormThemTungMH.controls[controlName].value.replace(/,/g, "");
			if (!this.FormThemTungMH.controls[controlName].invalid) {
				this.FormThemTungMH.controls[controlName].setValue(
					this.f_currency(this.formatNumber(tmpValue))
				);
			}
			if (tmpValue.indexOf('.') == 0 && tmpValue.length == 1) {
				tmpValue = 0;
			}
			this.FormThemTungMH.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else {
			this.FormThemTungMH.controls[controlName].setValue('' + event.target.value);
		}
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		;
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : String(event).match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			return false;;
		}

		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '0.00';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/*------------------------------------------------------------- */

	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/*------------------------------------------------------------- */

	async createBillNumber() {
		var category_path = this.KDDatHangItem.Type.toString() == ConstantPurchaseOrder.OPTION_FORECAST ? "FC" : "DHB";
		var res = await this.dungChung.getBillNumber(category_path).toPromise().then(r => { return r });
		if (res && res.status == 1) {
			return res.data;
		}
		else {

			this.layoutUtilsService.showErorr("Không thể lấy số phiếu tự động.");
		}
	}
	async createBillNumberFC() {
		var category_path = "FC";
		var res = await this.dungChung.getBillNumber(category_path).toPromise().then(r => { return r });
		if (res && res.status == 1) {
			return res.data;
		}
		else {

			this.layoutUtilsService.showErorr("Không thể lấy số phiếu tự động.");
		}
	}

	validateInvalidForm(isAddDetail: boolean = false) {
		const controls = this.FormThemTungMH.controls;
		if (this.FormThemTungMH.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = this.FormThemTungMH.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);

			return false;
		}
		return true;
	}
	validateInvalidSubForm(isAddDetail: boolean = false) {
		const controls = this.FormThemTungMH.controls;
		if (this.FormThemTungMH.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {

					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = this.FormThemTungMH.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName => {
				controls[controlName].markAsTouched()
			});
			return false;
		}

		// if(!isAddDetail){
		// 	this.forcusAnotherEmptyField(controls);
		// }
		return true;
	}

	getTienTeCurrent() {
		let index = this.currency_unit.findIndex(x => x.Id == +this.FormPhieu.controls['DONVI'].value);
		if (index > -1) {
			return this.currency_unit[index];
		}
		return null;
	}

	chonLoaiPhieu(value) {
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHangf = [];
		if (+value == 1) {
			this.vung_4 = true;
			this.vung_5 = false;
			this.FormThemTungMH.reset();
			this.FormThemTungMH.controls['MAHH'].setValue('');
			this.FormThemTungMH.controls['SOLUONG'].setValue('0,00');
			this.FormThemTungMH.controls['NGAYYCCHTU'].setValue(new Date());
			this.FormThemTungMH.controls['NGAYYCCHDEN'].setValue(new Date());
			this.selectId_HH = '';
		} else {
			this.vung_5 = true;
			this.vung_4 = false;
			this.FormPhieu.controls['TYGIA'].setValue('1,00');
			this.FormTongTien.controls['TONGTIENCHUATHUE'].setValue('0,00');
			this.FormTongTien.controls['THUE'].setValue('0,00');
			this.FormTongTien.controls['TONGTIEN'].setValue('0,00');
			this.checkAllThuocForecast();
		}
		this.changeDetectView();
	}

	ListId_HH() {
		this.deNghiMuaHangService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '')
			search = '' + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	afterSelectHH(value: string) {
		this.listId_HH.forEach(element => {
			if (element.Id_HH == +value) {
				this.selectId_HH = value;
				this.FormThemTungMH.controls["MAHH"].setValue(element.MaHH);
				this.FormThemTungMH.controls["TENHH"].setValue(element.TenHH);
				this.FormThemTungMH.controls["QUYCACH"].setValue(element.QuyCach);
				this.FormThemTungMH.controls["DVT"].setValue(element.TenDVT);
				this.validateInvalidSubForm();
			}
		});

	}
	selectedHH(event) {
		if (event.value) {
			this.listHH.forEach(x => {
				if (x.IdHH == Number(event.value)) {

					let controls = this.FormThemTungMH.controls;
					controls['TENHH'].setValue(x.TenHH);
					controls['DVT'].setValue(x.TenDVT);
					this.dataHH = x.IdHH;
				}
			})
		}
		this.changeDetectView();
	}
	clearSelectHH(event: any) {
		this.selectId_HH = '';
		this.FormThemTungMH.controls["MAHH"].setValue('');
		this.FormThemTungMH.controls["TENHH"].setValue('');
		this.FormThemTungMH.controls["QUYCACH"].setValue('');
		this.FormThemTungMH.controls["DVT"].setValue('');
		event.stopPropagation();
	}

	chonPhieuYCDG(event: any) { }
	clearYCDG(event: any) {
		this.FormPhieu.controls['MAKH'].setValue('');
		this.FormPhieu.controls['TENKH'].setValue('');
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.changeDetectView();
	}

	private f() {
		return this.FormThemTungMH;
	}

	addHangForecast() {
		if (this.invalidForm(this.FormThemTungMH) == false) return;
		if (this.dataHH == 0) return;

		let tmp = new KDDatHangChiTiet();

		if (moment(this.FormThemTungMH.controls['NGAYYCCHTU'].value) > moment(this.FormThemTungMH.controls['NGAYYCCHDEN'].value)) {
			this.layoutUtilsService.showErorr("Ngày yêu cầu có hàng không hợp lệ");
			return
		}

		this.listHH.forEach(x => {
			if (x.IdHH == this.dataHH) {
				tmp.IdHH = x.IdHH;
				tmp.MaHH = x.MaHH;
				tmp.TenHH = x.TenHH;
				tmp.DVT = x.DVT;
				tmp.TenDVT = x.TenDVT;
				tmp.KhoiLuong = this.customNumberFormat(this.f().controls['SOLUONG'].value);
				tmp.NgayGiaoHangTu = moment(this.f().controls['NGAYYCCHTU'].value).format("YYYY-MM-DD").toString();
				tmp.NgayGiaoHangDen = moment(this.f().controls['NGAYYCCHDEN'].value).format("YYYY-MM-DD").toString();
				tmp.GhiChu = this.FormThemTungMH.controls['GHICHU'].value;
				tmp.SoLuongDaGiao = 0;

				this.KDDatHangService.getTonKhoHangHoa_ById(+tmp.IdHH).subscribe(res => {
					if (res && res.status == 1) {
						tmp.SLCoPO = res.data.SLCoPO;
						tmp.SLTuDo = res.data.SLTuDo;
					}
				})
			}
		})
		const current_loaitien = this.getTienTeCurrent();
		if (current_loaitien != null) {
			tmp.TienTe_Id = current_loaitien.Id;
			tmp.TienTe_Ten = current_loaitien.Ten;
		}
		let i = this.findOverlappingForecastIndex(tmp);
		if (i == -1) {
			this.addNewForecast(tmp);
		} else {
			this.updateExistingOrderDetail(i, tmp);
		}

		let it = this.tmpChiTietKDDatHangf;
		this.tmpChiTietKDDatHangf = [];
		this.tmpChiTietKDDatHangf = [...it];
		// Sinh lại form
		this.dataHH = 0;
		this.fReset();
		this.changeDetectView();
	}

	private addNewForecast(newOrderDetail: KDDatHangChiTiet): void {
		this.tmpChiTietKDDatHangf.push(newOrderDetail);
	}

	private updateExistingOrderDetail(index: number, newOrderDetail: KDDatHangChiTiet): void {
		this.tmpChiTietKDDatHangf[index].KhoiLuong += newOrderDetail.KhoiLuong;
		this.tmpChiTietKDDatHangf[index].NgayGiaoHangTu = this.getMinDate(newOrderDetail.NgayGiaoHangTu, this.tmpChiTietKDDatHangf[index].NgayGiaoHangTu);
		this.tmpChiTietKDDatHangf[index].NgayGiaoHangDen = this.getMaxDate(newOrderDetail.NgayGiaoHangDen, this.tmpChiTietKDDatHangf[index].NgayGiaoHangDen);
	}

	private getMinDate(date1: string, date2: string): string {
		const firstDate = new Date(date1);
		const secondDate = new Date(date2);

		return firstDate < secondDate ? date1 : date2;
	}

	private getMaxDate(date1: string, date2: string): string {
		const firstDate = new Date(date1);
		const secondDate = new Date(date2);

		return firstDate > secondDate ? date1 : date2;
	}

	private findOverlappingForecastIndex(item: KDDatHangChiTiet, i: number = -1): number {
		const itemOfListIndex = this.tmpChiTietKDDatHangf
			.findIndex((d, index) => d.IdHH == item.IdHH &&
				(
					((item.NgayGiaoHangTu >= d.NgayGiaoHangTu) && (item.NgayGiaoHangTu <= d.NgayGiaoHangDen)) ||
					((item.NgayGiaoHangDen >= d.NgayGiaoHangTu) && (item.NgayGiaoHangDen <= d.NgayGiaoHangDen))
				) && (i > -1 ? i != index : true)
			);
		return itemOfListIndex;
	}

	private fReset() {
		this.f().controls['MAHH'].setValue('');
		this.f().controls['GHICHU'].setValue('');
		this.f().controls['DVT'].setValue('');
		this.f().controls['TENHH'].setValue('');
		this.f().controls['SOLUONG'].setValue('0,00');
	}

	addHangDG_Forecast() {
		let ids: number[] = [];
		this.YeuCauDuyetGiaService.CheckThoiHanGiuGia(ids).toPromise();

		const dialogRef = this.dialog.open(DsYeuCauDuyetGiaComponent, {
			data: {
				data: '',
				kw: '',
				idKH: this.FormPhieu.controls['MAKH'].value,
				BusinessModel: this.data.model
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.addHangDG_Forecast_DGItem(res.dataAdd);
					this.changeDetectView();
				}
			}
		});
	}
	addHangDG_Forecast_DGItem(data: any[]) {
		this.listYCDG.forEach(x => {
			if (data.includes(x.IdCt)) {
				let tmp = new KDDatHangChiTiet();
				tmp.IdHH = x.IdHH;
				tmp.MaHH = x.MaHH;
				tmp.TenHH = x.TenHH;
				tmp.DVT = x.DVT;
				tmp.TenDVT = x.TenDVT;
				tmp.KhoiLuong = x.SoLuong;
				tmp.oldKhoiLuong = x.SoLuong;
				tmp.NgayGiaoHangTu = moment(x.NgayYCGH).format("YYYY-MM-DD").toString();
				tmp.NgayGiaoHangDen = moment(x.NgayYCGH).format("YYYY-MM-DD").toString();
				tmp.GhiChu = '';
				tmp.SoLuongDaGiao = 0;


				this.KDDatHangService.getTonKhoHangHoa_ById(+tmp.IdHH).subscribe(res => {
					if (res && res.status == 1) {
						tmp.SLCoPO = res.data.SLCoPO;
						tmp.SLTuDo = res.data.SLTuDo;
					}
				})

				const current_loaitien = this.getTienTeCurrent();
				if (current_loaitien != null) {
					tmp.TienTe_Id = current_loaitien.Id;
					tmp.TienTe_Ten = current_loaitien.Ten;
				}
				let i = this.findOverlappingForecastIndex(tmp);
				if (i == -1) { this.addNewForecast(tmp); }
				else { this.updateExistingOrderDetail(i, tmp); }
			}
		});

		let it = this.tmpChiTietKDDatHangf;
		this.tmpChiTietKDDatHangf = [];
		this.tmpChiTietKDDatHangf = [...it];
		this.changeDetectView();
	}

	addHangLS() {
		if (this.invalidForm(this.FormPhieu) == false) return;
		const dialogRef = this.dialog.open(DsLishSuBanComponent, {
			data: {
				data: '',
				idKH: this.FormPhieu.controls['MAKH'].value,
				THKH: this.thongtinkk
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.addHangForecastLS(res.dataAdd);
					this.changeDetectView();
				}
			}
		});
	}
	addHangForecastLS(data: any[]) {
		this.listHH.forEach(x => {
			if (data.includes(x.IdHH)) {
				let tmp = new KDDatHangChiTiet();
				tmp.IdHH = x.IdHH;
				tmp.MaHH = x.MaHH;
				tmp.TenHH = x.TenHH;
				tmp.DVT = x.DVT;
				tmp.TenDVT = x.TenDVT;
				tmp.KhoiLuong = 0;
				tmp.NgayGiaoHangTu = moment(new Date()).format("YYYY-MM-DD").toString();
				tmp.NgayGiaoHangDen = moment(new Date()).format("YYYY-MM-DD").toString();
				tmp.GhiChu = '';
				tmp.SoLuongDaGiao = 0;
				const current_loaitien = this.getTienTeCurrent();
				if (current_loaitien != null) {
					tmp.TienTe_Id = current_loaitien.Id;
					tmp.TienTe_Ten = current_loaitien.Ten;
				}
				let i = this.findOverlappingForecastIndex(tmp);
				if (i == -1) { this.addNewForecast(tmp); }
				else { this.updateExistingOrderDetail(i, tmp); }
			}
		});

		let it = this.tmpChiTietKDDatHangf;
		this.tmpChiTietKDDatHangf = [];
		this.tmpChiTietKDDatHangf = [...it];
		this.changeDetectView();
	}

	addHangDG() {
		let ids: number[] = [];
		this.YeuCauDuyetGiaService.CheckThoiHanGiuGia(ids).toPromise();

		const dialogRef = this.dialog.open(DsYeuCauDuyetGiaComponent, {
			data: {
				data: '',
				kw: '',
				idKH: this.FormPhieu.controls['MAKH'].value,
				BusinessModel: this.data.model
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.addHang(res.dataAdd);
					this.changeDetectView();
				}
			}
		});
	}
	addHang(data: any[]) {
		this.listYCDG.forEach(x => {
			if (data.includes(x.IdCt)) {
				let tmp = new KDDatHangChiTiet();
				tmp.clear();
				let LoaiPhieu = +this.FormPhieu.controls['LOAIPHIEU'].value;
				tmp.YeuCauDuyetGiaCt = x.IdCt;
				tmp.SoPhieuYCDG = x.SoPhieuYCDG;
				tmp.IdHH = x.IdHH;
				tmp.MaHH = x.MaHH;
				tmp.TenHH = x.TenHH;
				tmp.QuyCach = x.QuyCach;
				tmp.DVT = x.DVT;
				tmp.TenDVT = x.TenDVT;
				tmp.DonGia = LoaiPhieu == 0 ? x.DonGia : 0;
				tmp.KhoiLuong = x.SoLuong;
				tmp.oldKhoiLuong = x.SoLuong;
				tmp.NgayGiaoHang = moment(x.NgayYCGH).format("YYYY-MM-DD").toString();
				//tmp.NgayGiaoHang = moment(this.currentDate).format("YYYY-MM-DD").toString();
				tmp.PhanTramThueVAT = x.PhanTramThueVAT;
				tmp.TienThueVAT = 0;
				tmp.SoLuongDaGiao = 0;
				tmp.ThanhTien = LoaiPhieu == 0 ? tmp.DonGia * tmp.KhoiLuong : 0;
				tmp.ThanhTienQuyDoi = LoaiPhieu == 0 ? tmp.DonGia * tmp.KhoiLuong * this.customNumberFormat(this.FormPhieu.controls['TYGIA'].value.toString()) : 0;
				tmp.TonKho = x.TonKho;

				this.KDDatHangService.getTonKhoHangHoa_ById(+tmp.IdHH).subscribe(res => {
					if (res && res.status == 1) {
						tmp.SLCoPO = res.data.SLCoPO;
						tmp.SLTuDo = res.data.SLTuDo;
					}
				})

				if (this.checkAll) {
					tmp.ThuocForecast = true;
				}
				const current_loaitien = this.getTienTeCurrent();

				if (current_loaitien != null) {
					tmp.TienTe_Id = current_loaitien.Id;
					tmp.TienTe_Ten = current_loaitien.Ten;
				}

				// Kiem tra da ton tai tu truoc chua
				if (!this.isPurchaseOrderB2C()) {
					let i = this.tmpChiTietKDDatHang.findIndex(x => x.IdHH == tmp.IdHH && x.SoPhieuYCDG == tmp.SoPhieuYCDG);
					if (i == -1) this.tmpChiTietKDDatHang.push(tmp);
					else {
						this.tmpChiTietKDDatHang[i].KhoiLuong += tmp.KhoiLuong;
						this.tmpChiTietKDDatHang[i].GhiChu = (this.tmpChiTietKDDatHang[i].GhiChu ? this.tmpChiTietKDDatHang[i].GhiChu + ', ' : '') + tmp.GhiChu ? tmp.GhiChu : '';
					}
				} else {
					this.tmpChiTietKDDatHang.push(tmp);
				}
			}
		})
		let it = this.tmpChiTietKDDatHang;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...it];
		this.updateThanhTienQuyDoi();
		this.changeDetectView();
	}
	addDetailRow(item: KDDatHangChiTiet) {
		let row = new DetailGiaoHang();
		row.clear();
		row.copy(item);
		item.isExpanded = true;

		if (item.ListDetailGiaoHang.length > 0) {
			row.KhoiLuong = +item.KhoiLuong / (item.ListDetailGiaoHang.length + 1);
			item.ListDetailGiaoHang.forEach(x => {
				x.KhoiLuong = +item.KhoiLuong / (item.ListDetailGiaoHang.length + 1);
				if (!x.DiaChiGiaoHang) {
					x.DiaChiGiaoHang = item.DiaChiGiaoHang ? item.DiaChiGiaoHang : "";
				}
				if (!x.BranchId) {
					x.BranchId = item.BranchId ? item.BranchId : null;
				}
			})
		}
		item.ListDetailGiaoHang.push(row);
		item.ListDetailGiaoHang = [...item.ListDetailGiaoHang];
		this.changeDetectView();
	}
	deleteItemDetail(master: KDDatHangChiTiet, item: DetailGiaoHang) {
		let index = master.ListDetailGiaoHang.indexOf(item, 0);
		if (index > -1) {
			master.ListDetailGiaoHang.splice(index, 1);
			if (master.ListDetailGiaoHang.length == 1) {
				master.ListDetailGiaoHang[0].KhoiLuong += item.KhoiLuong;
			}
		}
		let it = master.ListDetailGiaoHang;
		master.ListDetailGiaoHang = [];
		master.ListDetailGiaoHang = [...it];
		this.changeDetectView();
	}
	CopytoDetail(item: KDDatHangChiTiet) {
		if (item.ListDetailGiaoHang.length > 0) {
			item.ListDetailGiaoHang.forEach(x => {
				let kl = x.KhoiLuong;
				let date = x.NgayGiaoHang;
				let address = x.DiaChiGiaoHang;
				x.copy(item);
				x.KhoiLuong = kl;
				x.NgayGiaoHang = date;
				x.DiaChiGiaoHang = address;
			})
		}
	}
	checkSLMaster(master: KDDatHangChiTiet, event) {
		master.KhoiLuong = event.target.value.replace(/\./g, "").replace(/,/g, ".");
		let min = 0;
		if (master.ListDetailGiaoHang.length > 0) {
			master.ListDetailGiaoHang.forEach(x => { min += x.KhoiLuong; });
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (event.target.value) {
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
			}
			// if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
			// 	tmpValue = min;
			// }
			event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
		}
		else {
			event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
		}

		if (master.ListDetailGiaoHang.length > 0) {
			master.ListDetailGiaoHang.forEach(l => {
				this.checkSLDetail(master, l, event);
			})
		}
	}
	checkSLDetail(master: KDDatHangChiTiet, child: any, event) {
		let max = -1;
		if (master.ListDetailGiaoHang.length > 0) {
			max = master.KhoiLuong;
			master.ListDetailGiaoHang.forEach(x => {
				if (max - (+x.KhoiLuong) >= 0 && x != child)
					max -= (+x.KhoiLuong);
			})
		}
		if (max > -1) {
			if (this.ValidateChangeNumberForm(event)) {
				let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

				if (Number(tmpValue) >= max) tmpValue = max;

				if (event.target.value) {
					event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
				}
				if (('' + tmpValue).indexOf(',') == 0 && tmpValue.length == 1) {
					tmpValue = max;
				}
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
				child.KhoiLuong = tmpValue;
			}
			else {
				event.target.value = this.f_currency_VND(this.formatNumber(max.toString()));
				child.KhoiLuong = max;
			}
		}
	}
	changeNgayYCGiaoHangMaster(master: KDDatHangChiTiet, rowMaster: boolean = false) {
		// Update delivery dates for child items if rowMaster is true
		if (rowMaster && master.ListDetailGiaoHang && master.ListDetailGiaoHang.length > 0) {
			master.ListDetailGiaoHang.forEach(child => {
				child.NgayGiaoHang = master.NgayGiaoHang;
			});
		}

		if (master && master.ForecastDetailId && Number(master.ForecastDetailId > 0)) {
			const { ListForecast } = master;
			const option = ListForecast.find(o => o.IdCt == Number(master.ForecastDetailId));
			const invalidOption = this.disableOptionForecast(master, option);

			if (invalidOption) {
				master.Forecast_Id = null;
				master.ForecastDetailId = null;
			}
		}
	}
	calThanhTien(item: KDDatHangChiTiet) {
		this.tmpChiTietKDDatHang.forEach(x => { x.ThanhTien = x.KhoiLuong * x.DonGia; });
		this.updateThanhTienQuyDoi();
		this.refreshList();
	}

	dateToDDMMYYYY(__data: any) {
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2) + "/" + ("0" + (__date.getMonth() + 1)).slice(-2) + "/" + __date.getFullYear();
	}

	clickThuocForecast(event, item: KDDatHangChiTiet) {
		if (event.checked == true) {
			this.listThuocForecast.push(item.IdHH);
			item.ThuocForecast = true;
		} else {
			let i = this.listThuocForecast.findIndex(x => x == item.IdHH);
			if (i > -1) this.listThuocForecast.splice(i, 1);
			item.ThuocForecast = false;
		}
		let it = this.tmpChiTietKDDatHang;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...it];
		this.changeDetectView();
	}

	clickThuocForecastAll(event) {
		if (event.checked == true) {
			this.tmpChiTietKDDatHang.forEach(x => {
				this.listThuocForecast.push(x.IdHH);
				x.ThuocForecast = true;
			});
		} else {
			this.listThuocForecast = [];
			this.tmpChiTietKDDatHang.forEach(x => {
				x.ThuocForecast = false;
			});
		}
		let it = this.tmpChiTietKDDatHang;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...it];
		this.changeDetectView();
	}


	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.FormPhieu.controls['TRANGTHAI'].setValue(this.TinhTrang[1].Name);
		} else {
			this.FormPhieu.controls['TRANGTHAI'].setValue(this.TinhTrang[0].Name);
		}
	}

	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	changeValueOfColumn(columnName: string, item: any, event: any, afterUpdate: boolean) {
		if (columnName == 'SOLUONG') {
			if (afterUpdate)
				this.tmpChiTietKDDatHang[this.tmpChiTietKDDatHang.indexOf(item)].SOLUONG = this.formatNumber(item.SOLUONG);
			else if (!afterUpdate) {

				this.tmpChiTietKDDatHang[this.tmpChiTietKDDatHang.indexOf(item)].SOLUONG = event.target.value.trim().replace(/,/g, "");
				item.ThanhTien = item.SOLUONG * item.DonGia;
				let ToTal = 0;
				this.tmpChiTietKDDatHang.forEach(x => {
					ToTal += x.ThanhTien;
				});
				this.FormTongTien.controls['TONGTIEN'].setValue(this.f_currency(this.formatNumber('' + ToTal)));
				this.changeDetectView();
			}
		}
		if (columnName == 'GHICHU') {
			if (afterUpdate)
				this.tmpChiTietKDDatHang[this.tmpChiTietKDDatHang.indexOf(item)].GhiChu = item.GhiChu;
			else if (!afterUpdate) {

				this.tmpChiTietKDDatHang[this.tmpChiTietKDDatHang.indexOf(item)].GhiChu = event.target.value.trim().replace(/,/g, "");
				this.changeDetectView();
			}
		}
	}
	checkLoaiPhieu() {
		return this.FormThemTungMH.controls['LOAIPHIEU'].value;
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: KDDatHangChiTiet) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}

	anHienTheoThaoTac() {
		//if(+this.FormPhieu.controls["LOAIPHIEU"].value == 0) this.vung_5 = false;
		var loaiphieu = this.FormPhieu.controls["LOAIPHIEU"].value;
		if (this.them_moi || this.chinh_sua || this.thay_doi_forecast) {
			this.vung_1 = false;
			this.vung_2 = false;
			this.vung_3 = false;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = false;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
		}
		if (this.chi_tiet) {
			this.vung_1 = true;
			this.vung_2 = true;
			this.vung_3 = true;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = true;
			this.vung_7 = true;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
			this.FormTPDuyet.disable();
			this.FormKHXacNhan.disable();
			this.FormChotDonHang.disable();
			this.FormDongDonHang.disable();
			this.FormNVKDConfirm.disable();
			this.isWaitToPlanningEmployee = true;
		}
		if (this.duyet_phieu) {
			this.vung_1 = true;
			this.vung_2 = false;
			this.vung_3 = false;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = false;
			this.vung_7 = true;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
			if (this.isWaitToPlanningEmployee) {
				this.FormTPDuyet.disable();
			}
		}
		if (this.xac_nhan) {
			this.vung_1 = true;
			this.vung_2 = true;
			this.vung_3 = false;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = false;
			this.vung_7 = true;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
			this.FormTPDuyet.disable();
			this.FormNVKDConfirm.disable();
			this.isWaitToPlanningEmployee = true;
		}
		if (this.chot_don_hang) {
			this.vung_1 = true;
			this.vung_2 = true;
			this.vung_3 = true;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = false;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
			this.FormTPDuyet.disable();
			this.FormKHXacNhan.disable();
		}
		if (this.dong_don_hang) {
			this.vung_1 = true;
			this.vung_2 = true;
			this.vung_3 = true;
			this.vung_5 = true;
			this.vung_4 = true;
			this.vung_6 = true;
			if (loaiphieu == "0") {
				this.vung_4 = false;
			}
			else {
				this.vung_5 = false;
			}
			this.FormTPDuyet.disable();
			this.FormKHXacNhan.disable();
			this.FormChotDonHang.disable();
		}

		if (this.duyet_phieu || this.xac_nhan || this.chot_don_hang || this.chi_tiet || this.thay_doi_forecast || this.dong_don_hang) {
			this.FormPhieu.disable();
			this.FormTongTien.disable();
			//this.changeDetectView();
			if (this.chi_tiet && this.KDDatHangItem.IsChangeCustomerPurchaseOrder && this.checkControlExists('CUSTOMER_PURECHASE_ORDER')) {
				this.FormPhieu.controls['CUSTOMER_PURECHASE_ORDER'].enable();
			}
		}
	}
	anHienGiaTien(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		this.availableColumns = [
			{
				stt: 0,
				name: 'checkbox',
				displayName: 'checkbox',
				alwaysChecked: true,
				isShow: true
			},
			{
				stt: 1,
				name: '#',
				displayName: '#',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 2,
				name: 'MAHH',
				displayName: 'Mã hàng',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 3,
				name: 'TENHH',
				displayName: 'Tên hàng',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 4,
				name: 'SL',
				displayName: 'Số lượng',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 5,
				name: 'DONVITINH',
				displayName: 'Đơn vị tính',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 6,
				name: 'DONGIA',
				displayName: 'Đơn giá',
				alwaysChecked: false,
				isShow: false
			},
			{
				stt: 6,
				name: 'SOLUONGDAGIAO',
				displayName: 'Số lượng đã giao',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 6,
				name: 'SOLUONGTONKHO',
				displayName: 'Số lượng tồn kho',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 7,
				name: 'NGAYYCGIAOHANG',
				displayName: 'Ngày YC giao hàng',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 8,
				name: 'THANHTIEN',
				displayName: 'Thành tiền',
				alwaysChecked: false,
				isShow: false
			},
			{
				stt: 9,
				name: 'THANHTIENQUYDOI',
				displayName: 'Thành tiền quy đổi',
				alwaysChecked: false,
				isShow: false
			},
			{
				stt: 10,
				name: 'PHANTRAMTHUE',
				displayName: '% Thuế GTGT',
				alwaysChecked: false,
				isShow: false
			},
			{
				stt: 11,
				name: 'THUEGTGT',
				displayName: 'Thuế GTGT',
				alwaysChecked: false,
				isShow: false
			},
			{
				stt: 12,
				name: 'DIACHIGIAOHANG',
				displayName: 'Địa chỉ giao hàng',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 12,
				name: 'GHICHU',
				displayName: 'Ghi chú',
				alwaysChecked: false,
				isShow: true
			},
			{
				stt: 13,
				name: 'THUOCFC',
				displayName: 'Thuộc forecast',
				alwaysChecked: false,
				isShow: true
			}
		];
    
    if (this.chi_tiet) {
      const position = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.position;
      const columns = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.columns;
      const positionExtendDetail = ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN_DETAIL.positionExtendDetail;
      this.availableColumns.splice(position, 0, columns);
      this.availableColumnsDetail.splice(positionExtendDetail, 0, columns);
    }

		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		return false;
	}

	showErrorInputSL() {
		let message = "";
		let controls = this.FormThemTungMH.controls;
		if (controls['SOLUONG'].value.length == 0 || this.customNumberFormat(controls['SOLUONG'].value) == 0) return 'Số lượng là bắt buộc';
		if (controls['SOLUONG'].hasError('maxlength')
			|| (controls['SOLUONG'].value.length > 22
				&& (controls['SOLUONG'].value.indexOf(',') == 0 || controls['SOLUONG'].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}

	refreshList() {
		let tmp = this.tmpChiTietKDDatHang;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...tmp];
		this.updateMoney();
		this.changeDetectView();
	}

	updateThueGTGT() {
		let thue = this.customNumberFormat(this.FormTongTien.controls['THUE'].value.toString());
		//if(!thue) thue = 0;
		this.FormTongTien.controls['THUE'].setValue(this.f_currency_VND(this.formatNumber(thue.toString())));
		this.updateMoney();
		this.changeDetectView();
	}

	showOptions(event) {
		this.tmpChiTietKDDatHang.forEach(x => {
			x.ThuocForecast = event.checked;
			if (event.checked == true) {
				this.getListForecast(x);
			}
			else {
				x.ListForecast = [];
				x.filteredListForecast.next(x.ListForecast.slice());
				x.ThuocForecast = false;
				x.Forecast_Id = null;
				x.Forecast_SoPhieu = null;
			};
		})
		this.refreshList();
	}

	checkAllThuocForecast() {
		let sum = 0;
		this.tmpChiTietKDDatHang.forEach(x => {
			if (x.ThuocForecast) sum += 1;
		})
		if (sum == this.tmpChiTietKDDatHang.length && sum > 0) this.checkAll = true;
		else this.checkAll = false;

		this.changeDetectView();
	}

	changePayments(event) {
		let tiente_id = +event.value;
		let index = this.currency_unit.findIndex(a => a.Id === tiente_id);
		let tiente_ten = '';
		if (index > -1) tiente_ten = this.currency_unit[index].Ten;

		if (tiente_id > 0 && tiente_ten) {
			this.tmpChiTietKDDatHang.forEach(x => {
				x.TienTe_Id = tiente_id;
				x.TienTe_Ten = tiente_ten;
			})
			this.refreshList();
			this.changeDetectView();
		}
	}

	setDonHangBan(status: number = 0) {

		const UNSELECTED_ITEM_WARNING_MESSAGE = "Bạn chưa chọn hàng cần thay đổi";
		const ADD_DETAILS_RECEIPT_WARNING_MESSAGE = 'Vui lòng thêm chi tiết phiếu.';
		const UNSELECTED_FORECAST_WARNING_MESSAGE = "Bạn chưa chọn Forecast cho mặt hàng";
		const UNSELECTED_DATE_REQUIRED_WARNING_MESSAGE = "Bạn chưa chọn Ngày yêu cầu giao hàng";
		const FORECAST_CHANGE_BOOL = this.thay_doi_forecast;
		const TYPE_DONHANGBAN = 0;
		const SAVE_AND_ADD_NEW = 2;
		const SAVE_ONLY = 1;
		const API_SERVICE = this.donHangBanService;
		const LAYOUT_UTILS_SERVICE = this.layoutUtilsService;
		const UNSELECTED_ADDRESS_REQUIRED_WARNING_MESSAGE = "Bạn chưa chọn Địa chỉ giao hàng";
		const INVALID_DATE_REQUIRE_WITH_FORECAST = "Vui lòng chọn ngày yc giao hàng trong khoảng thời gian forecast đã chọn.";
		const form = this.FormPhieu.controls;

		// .. Kiểm tra dữ liệu form
		if (this.invalidForm(this.FormPhieu) == false) return;
		if (this.invalidForm(this.FormTongTien) == false) return;

		// .. Tạo dữ liệu
		var data = this.createItem();

		// .. Nếu phiếu loại đơn hàng bán và form phiếu invalid 
		if (data.Type == TYPE_DONHANGBAN && this.invalidForm(this.FormPhieu) == false)
			return false;

		// .. Nếu chi tiết phiếu trống
		if (data.Cts.length == 0) {
			const messageError = FORECAST_CHANGE_BOOL ? UNSELECTED_ITEM_WARNING_MESSAGE : ADD_DETAILS_RECEIPT_WARNING_MESSAGE;
			LAYOUT_UTILS_SERVICE.showErorr(messageError);
			return false;
		}

		// .. Kiểm tra dữ liệu chi tiết
		if (!FORECAST_CHANGE_BOOL) {
			// .. Cảnh báo chưa chọn FC mặt hàng khi đã chọn Thuộc FC
			let isError = data.Cts.findIndex(x => x.ThuocForecast && (!x.ForecastDetailId || x.ForecastDetailId == 0));
			if (isError > -1 && data.Type == TYPE_DONHANGBAN) {
				LAYOUT_UTILS_SERVICE.showErorr(UNSELECTED_FORECAST_WARNING_MESSAGE);
				return false;
			}

			// .. Cảnh báo chưa chọn ngày yêu cầu giao hàng
			var invalidDate = data.Cts.findIndex(x => this.isInvalidDate(x, data.Type, TYPE_DONHANGBAN));
			if (invalidDate > -1) {
				LAYOUT_UTILS_SERVICE.showErorr(UNSELECTED_DATE_REQUIRED_WARNING_MESSAGE);
				data.Cts.forEach(d => {
					if (d.NgayGiaoHang == 'Invalid date') d.NgayGiaoHang = '';
					if (d.NgayGiaoHangTu == 'Invalid date') d.NgayGiaoHangTu = '';
					if (d.NgayGiaoHangDen == 'Invalid date') d.NgayGiaoHangDen = '';
				});
				return false;
			}

			// .. Cảnh báo chưa chọn Địa chỉ giao hàng
			var invalidAddress = data.Cts.findIndex(x => !x.DiaChiGiaoHang || x.DiaChiGiaoHang == "");
			if (invalidDate > -1) {
				LAYOUT_UTILS_SERVICE.showErorr(UNSELECTED_ADDRESS_REQUIRED_WARNING_MESSAGE);
				return false;
			}
			var invalidAddressFlag = false;
			var invalidForecastDate = [];
			var record = 1;
			// .. Chỉ kiểm tra địa chỉ giao hàng bắt buộc nhập khi loại phiếu 'Đơn hàng khách hàng'
			if (form["LOAIPHIEU"].value == ConstantPurchaseOrder.OPTION_PURCHASEORDER) {
				data.Cts.forEach(a => {
					if (!invalidAddressFlag) {
						if (!invalidAddressFlag && (!a.ListDetailGiaoHang || a.ListDetailGiaoHang.length == 0) && (!a.DiaChiGiaoHang || a.DiaChiGiaoHang.trim() == "")) {
							invalidAddressFlag = true;
							LAYOUT_UTILS_SERVICE.showErorr(UNSELECTED_ADDRESS_REQUIRED_WARNING_MESSAGE);
							return;
						}
						if (!invalidAddressFlag && a.ListDetailGiaoHang && a.ListDetailGiaoHang.length > 0) {
							a.ListDetailGiaoHang.forEach(b => {
								if (!b.DiaChiGiaoHang || b.DiaChiGiaoHang.trim() == "") {
									invalidAddressFlag = true;
									LAYOUT_UTILS_SERVICE.showErorr(UNSELECTED_ADDRESS_REQUIRED_WARNING_MESSAGE);
									return;
								}
							})
						}
					}
					if (invalidForecastDate) {
						const { ForecastDetailId, ListForecast, NgayGiaoHang, ListDetailGiaoHang, ThuocForecast } = a;

						if (!ForecastDetailId || !ThuocForecast || !ListForecast) {
							record += (ListDetailGiaoHang.length + 1) || 1;
							return;
						}
						const option = ListForecast.find(d => d.IdCt == ForecastDetailId);
						const { DateRequestFrom, DateRequestTo } = option || { DateRequestFrom: null, DateRequestTo: null };

						if (!NgayGiaoHang || !DateRequestFrom || !DateRequestTo) {
							record += (ListDetailGiaoHang.length + 1) || 1;
							return;
						}

						if (ListDetailGiaoHang && ListDetailGiaoHang.length > 0) {
							ListDetailGiaoHang.forEach((detail) => {
								record++;
								if (this.isDateRequiredInvalid(option, detail)) {
									invalidForecastDate.push(record);
								}
							});
						} else {
							if (this.isDateRequiredInvalid(option, a)) {
								invalidForecastDate.push(record);
							}
						}
					}
					record++;
				});
				if (invalidForecastDate.length > 0) {
					LAYOUT_UTILS_SERVICE.showErorr(`Dòng ${invalidForecastDate.join(",")} có thời gian giao hàng không thuộc FC được chọn.`);
					return;
				}
				if (invalidAddressFlag) return;
			}
		}
		data.BusinessModel = this.data.model;
		// ..
		if (data) {
			// .. Xử lý gửi, gửi và thêm mới
			if ([SAVE_ONLY, SAVE_AND_ADD_NEW].includes(status)) {
				data.TrangThai_Code = this.TinhTrang[1].Code;
				const _sophieu: string = data.SoPhieu;
				const dialogRef = LAYOUT_UTILS_SERVICE.POP02(_sophieu);
				dialogRef.afterClosed().subscribe(res => {
					if (!res) { return; }
					if (FORECAST_CHANGE_BOOL) {
						var param = new HistoriesForecastChangeParam();
						param.DatHangId = data.IdDH;
						param.Details = data.Cts.map(x => {
							let detail = new HistoriesForecastChangeDetailParam();
							detail.DatHangCtId = x.IdCt;
							detail.SoLuongThayDoi = x.QuantityToBeConfirmed;
							detail.GhiChu = x.GhiChu;
							return detail;
						});

						API_SERVICE.ThayDoiForeCast(param).subscribe(res => this.runAfterAddOrUpdate(res, status, false))
					}
					else if (data.IdDH > 0) {
						API_SERVICE.editOrder(data).subscribe(res => this.runAfterAddOrUpdate(res, status, false))
					} else {
						API_SERVICE.insertOrder(data).subscribe(res => this.runAfterAddOrUpdate(res, status, true))
					}
				});
			}
			// .. Xử lý cho lưu nháp
			else {
				data.TrangThai_Code = this.TinhTrang[0].Code;
				if (FORECAST_CHANGE_BOOL) {
					var param = new HistoriesForecastChangeParam();
					param.DatHangId = data.IdDH;
					param.Details = data.Cts.map(x => {
						let detail = new HistoriesForecastChangeDetailParam();
						detail.DatHangCtId = x.IdCt;
						detail.SoLuongThayDoi = x.QuantityToBeConfirmed;
						detail.GhiChu = x.GhiChu;
						return detail;
					});
					API_SERVICE.ThayDoiForeCast(param).subscribe(res => this.runAfterAddOrUpdate(res, status, false))
				}
				else if (data.IdDH > 0) {
					API_SERVICE.editOrder(data).subscribe(res => this.runAfterAddOrUpdate(res, status, false))
				} else {
					API_SERVICE.insertOrder(data).subscribe(res => this.runAfterAddOrUpdate(res, status, true))
				}
			}
		}
	}

	invalidForm(formGroup) {
		const controls = formGroup.controls;
		if (formGroup.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = formGroup.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}
	}
	async resetForm() {
		const form = this.FormPhieu.controls;
		const sumForm = this.FormTongTien.controls;
		const initialCurrency = (this.currency_unit.length > 0) ? this.currency_unit[0].Id.toString() : '';

		var tenNguoiLap = await this.tokenStorage.getFullName().toPromise();

		this.FormPhieu.reset();
		this.KDDatHangItem = new KDDatHang();
		this.KDDatHangItem.IdDH = 0;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.tmpChiTietKDDatHangf = [];
		this.tmpChiTietKDDatHangf = [...this.tmpChiTietKDDatHangf];

		this.createBillNumber().then(r => {
			form['SOPHIEU'].setValue(r);
		});

		form['NGAYLAPPHIEU'].setValue(new Date());
		form['LOAIPHIEU'].setValue('0');
		form['NGUOILAPPHIEU'].setValue(tenNguoiLap);
		form['TRANGTHAI'].setValue(this.TinhTrang[0].Name);
		form['DONVI'].setValue(initialCurrency);
		form['TYGIA'].setValue(this.f_currency_VND(this.formatNumber('1')));

		const initialCurrencyValue = this.f_currency_VND(this.formatNumber('0'));
		sumForm['TONGTIENCHUATHUE'].setValue(initialCurrencyValue);
		sumForm['THUE'].setValue(initialCurrencyValue);
		sumForm['TONGTIEN'].setValue(initialCurrencyValue);

		this.checkAll = false;
	}

	createItem() {
		const FORM = this.FormPhieu.controls;
		const SUBFORM = this.FormTongTien.controls;
		const tyGia = FORM['TYGIA'].value.toString();

		// .. Create new data
		const data = new KDDatHang();
		data.clear();
		data.SoPhieu = FORM['SOPHIEU'].value;
		data.Type = Number(FORM['LOAIPHIEU'].value);
		data.IdKH = Number(FORM['MAKH'].value.toString());
		data.GhiChu = FORM['GHICHU'].value;

		if (this.checkControlExists('CUSTOMER_PURECHASE_ORDER')) {
			data.CustomerPurchaseOrder = FORM['CUSTOMER_PURECHASE_ORDER'].value;
			if (this.priceEvidenceFiles.length > 0) {
				data.PriceEvidenceFiles = this.priceEvidenceFiles.map(file => ({
					...file,
					fileByte: null
				}));
			}
		}
		// .. Set id
		if (this.KDDatHangItem.IdDH > 0)
			data.IdDH = this.KDDatHangItem.IdDH;

		// .. Get data details
		if (data.Type == 0) {
			const tienChuaThue = SUBFORM['TONGTIENCHUATHUE'].value.toString();
			const tongTien = SUBFORM['TONGTIEN'].value.toString();

			data.TongTienChuaThue = this.customNumberFormat(tienChuaThue);
			data.TongTien = this.customNumberFormat(tongTien);

			data.Cts = this.tmpChiTietKDDatHang.map(item => ({
				...item,
				TyGia: this.customNumberFormat(tyGia),
				NgayGiaoHang: this.customDateFormat(item.NgayGiaoHang),
				ListDetailGiaoHang: item.ListDetailGiaoHang.map(detail => ({
					...detail,
					NgayGiaoHang: this.customDateFormat(detail.NgayGiaoHang)
				})),
				POOfCustomer: item.POOfCustomer,
				BranchId: item.BranchId ? Number(item.BranchId) : null,
				Forecast_Id: item.Forecast_Id ? Number(item.Forecast_Id) : null,
				ForecastDetailId: item.ForecastDetailId ? Number(item.ForecastDetailId) : null
			}));
		}
		else {
			const newDetails = [];
			this.tmpChiTietKDDatHangf.forEach(item => {
				const startDate = moment(item.NgayGiaoHangTu);
				const endDate = moment(item.NgayGiaoHangDen);
				
				if (startDate.month() !== endDate.month()) {
					let currentStart = startDate.clone();
					
					while (currentStart.isBefore(endDate) || currentStart.isSame(endDate, 'month')) {
						const monthEnd = currentStart.clone().endOf('month');
						const newItem = {
							...item,
							NgayGiaoHangTu: currentStart.toDate(),
							NgayGiaoHangDen: monthEnd.isBefore(endDate) ? monthEnd.toDate() : endDate.toDate()
						};
						newDetails.push(newItem);
						currentStart = monthEnd.add(1, 'day');
					}
				} else {
					newDetails.push(item);
				}
			});

			data.Cts = newDetails;
		}

		if (this.isPurchaseOrderB2C()) {
			data.LoaiChietKhau = FORM['LOAICHIETKHAU'].value.toString();
			data.TenLoaiChietKhau = ConstantPurchaseOrder.DROPDOWN_LOAICHIETKHAU.find(o => o.key == data.LoaiChietKhau).value;
			data.GiaTriChietKhau = FORM['GIATRICHIETKHAU'].value.toString();
		}

		if (this.isForecastB2C()) {
			data.ChannelOrPlatform = FORM['KENHSAN'].value || '';
		}
		return data;
	}
	createItemChangeForecast() {
		const FORM = this.FormPhieu.controls;
		const controlsMoney = this.FormTongTien.controls;
		const controlsTG = this.FormPhieu.controls;
		const data = new KDDatHang();
		data.clear();
		data.SoPhieu = FORM['SOPHIEU'].value;
		data.Type = Number(FORM['LOAIPHIEU'].value);
		data.IdKH = Number(FORM['MAKH'].value.toString());
		data.GhiChu = FORM['GHICHU'].value.toString();
		data.IdDH = 0;
		data.CustomerPurchaseOrder = FORM['CUSTOMER_PURECHASE_ORDER'].value;
		this.originalChangeForecast.forEach(a => {
			a.TyGia = this.customNumberFormat(FORM['TYGIA'].value.toString());
		});
		if (this.priceEvidenceFiles.length > 0) {
			data.PriceEvidenceFiles = this.priceEvidenceFiles.map(file => ({
				...file,
				fileByte: null
			}));
		}
		data.Cts = this.originalChangeForecast;
		return data;
	}

	runAfterAddOrUpdate(res, withBack, add) {
		if (res && res.status == 1) {
			this.isChange = true;
			const message = this.FormPhieu.controls['SOPHIEU'].value + ` đã được ` + (add ? `thêm` : 'cập nhật') + ` thành công.`;
			this.layoutUtilsService.showInfo(message);

			//Cập nhật lại khi đã thêm
			this.saveAddedTTHV = [];
			this.saveAddedTTHV.push(res.data.IdDH);
			if (this.thay_doi_forecast) {
				this.back(false);
			}
			// Luu nháp
			if (withBack == 0) {
				this.them_moi = false;
				this.chinh_sua = true;
				this.KDDatHangItem = res.data;
				this.FormPhieuInit = Object.assign({}, this.FormPhieu);
				this.changeDetectView();
				return;
			}

			this.checkGuiDuyet(false);
			// Lưu và thêm mới
			if (withBack == 2) {
				let temp = this.FormPhieu.controls['LOAIPHIEU'].value;
				this.resetForm();


				this.FormPhieu.controls['LOAIPHIEU'].setValue(temp + '');

				this.them_moi = true;
				this.chinh_sua = false;
				this.changeDetectView();
				return;
			}

			// Lưu và trờ lại
			if (withBack == 1) {
				this.FormPhieu.reset();
				this.tmpChiTietKDDatHang = [];
				this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
				this.tmpChiTietKDDatHangf = [];
				this.tmpChiTietKDDatHangf = [...this.tmpChiTietKDDatHangf];
				this.back(false);
			}

			this.isChange = true;
			this.back(false);
		}
		else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	back(isCheckChange: boolean = true) {
		var messageWarn = "Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?";
		var backObj = { isChange: this.isChange, dataAdd: this.saveAddedTTHV };
		var isWarnNotif = isCheckChange ? this.isChangeContextForm() : false;
		if (!isWarnNotif) {
			this.dialogRef.close(backObj);
		} else {
			const dialogRef = this.layoutUtilsService.POPConfirm(messageWarn);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) return;
				this.dialogRef.close(backObj);
			});
		}
	}

	setDuyetPhieu(status: boolean) {
		let formGroup, code;
		formGroup = this.isWaitToPlanningEmployee ? this.FormNVKDConfirm : this.FormTPDuyet;
		let controls = formGroup.controls;
		if (status === false) {
			formGroup.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			formGroup.controls['LYDO'].updateValueAndValidity();
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr(`Vui lòng nhập lý do không ${this.isWaitToPlanningEmployee ? 'xác nhận' : this.subTitleAccept}`);
				return;
			}
		}

		const _sophieu = this.KDDatHangItem.SoPhieu;

		if (status) {
			formGroup.controls['LYDO'].clearValidators();
			formGroup.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[3].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: '', // NoiDung: controls['LYDO'].value, -- ' Cập nhật [29032023] Duyệt không lưu lý do vào chi tiết '
					LoaiThaoTac: this.findNextState(status, this.KDDatHangItem.TrangThai_Code),
					Loai: this.KDDatHangItem.Type
				};
				this.KDDatHangService.acceptOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[2].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: controls['LYDO'].value,
					LoaiThaoTac: this.findNextState(status, this.KDDatHangItem.TrangThai_Code),
					Loai: this.KDDatHangItem.Type
				};
				this.KDDatHangService.acceptOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}
	setXacNhan(status: boolean) {
		let formGroup, code;
		formGroup = this.FormKHXacNhan;
		let controls = formGroup.controls;
		if (status === false) {
			formGroup.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			formGroup.controls['LYDO'].updateValueAndValidity();
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr(
					`Vui lòng nhập lý do ${this.isForecastB2C() ? "không " + this.subTitleConfirm : this.CONFIG.BUTTON_FORM.DENY.titleLowerCase}`
				);
				return;
			}
		}
		const _sophieu = this.KDDatHangItem.SoPhieu;
		this.KDDatHangItem.KHDuyet_LyDo = controls['LYDO'].value;
		if (status) {
			formGroup.controls['LYDO'].clearValidators();
			formGroup.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[5].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: '', // NoiDung: controls['LYDO'].value, -- ' Cập nhật [29032023] Xác nhận không lưu lý do vào chi tiết '
					LoaiThaoTac: this.TinhTrang[5].Code
				};
				this.KDDatHangService.confirmOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[4].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: controls['LYDO'].value,
					LoaiThaoTac: this.TinhTrang[4].Code
				};
				this.KDDatHangService.confirmOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}
	setChotDonHang(status: boolean) {
		let formGroup, code;
		formGroup = this.FormChotDonHang;
		let controls = formGroup.controls;
		if (status === false) {
			formGroup.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			formGroup.controls['LYDO'].updateValueAndValidity();
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				this.layoutUtilsService.showErorr("Vui lòng nhập lý do không chốt đơn hàng");
				return;
			}
		}
		const _sophieu = this.KDDatHangItem.SoPhieu;
		this.KDDatHangItem.NguoiChotDon_LyDo = controls['LYDO'].value;
		if (status) {
			formGroup.controls['LYDO'].clearValidators();
			formGroup.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[7].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: controls['LYDO'].value,
					LoaiThaoTac: this.TinhTrang[10].Code
				};
				this.KDDatHangService.completeOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				//this.KDDatHangItem.TrangThai_Code = this.TinhTrang[6].Code;
				const _data = {
					IdDH: this.KDDatHangItem.IdDH,
					NoiDung: controls['LYDO'].value,
					LoaiThaoTac: this.TinhTrang[6].Code
				};
				this.KDDatHangService.completeOrder(_data).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}
	setDongDonHang() {
		let formGroup, code;
		formGroup = this.FormDongDonHang;
		let controls = formGroup.controls;
		if (formGroup.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.layoutUtilsService.showErorr("Vui lòng nhập lý do đóng đơn hàng");

			return;
		}
		const _sophieu = this.KDDatHangItem.SoPhieu;
		//this.KDDatHangItem.NguoiChotDon_LyDo = controls['LYDO'].value;
		const dialogRef = this.layoutUtilsService.POP02(_sophieu);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			const _data = {
				IdDH: this.KDDatHangItem.IdDH,
				NoiDung: controls['LYDO'].value,
				LoaiThaoTac: this.TinhTrang[7].Code
			};
			this.KDDatHangService.DatHang_Dong(_data).subscribe(res => {
				this.showAfterConfirm(_sophieu, res);
			});
		});

	}

	showAfterConfirm(_sophieu, res) {
		if (res && res.status === 1) {
			const message = _sophieu + ' cập nhật thành công.';
			this.layoutUtilsService.showInfo(message);
			this.isChange = true;
			this.saveAddedTTHV.push(res.data);
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	openThongTinXacNhan(item: KDDatHangChiTiet, type: number) {
		this.open_thongtinxacnhan = true;
		this.openComponent(this.KDDatHangItem.Type == 0 ? ThongTinXacNhanComponent : ThongTinXacNhanFCComponent, item);
	}

	openComponent(component, item) {
		const stateConfirm = [this.TinhTrang[3].Code];
		const stateDetail = [this.TinhTrang[5].Code, this.TinhTrang[7].Code, this.TinhTrang[10].Code];
		const dialogRef = this.dialog.open(component, {
			data: {
				data: item,
				xac_nhan: stateConfirm.includes(this.KDDatHangItem.TrangThai_Code),
				chi_tiet: stateDetail.includes(this.KDDatHangItem.TrangThai_Code)
			},
			maxHeight: '90vh',
			width: '50vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.open_thongtinxacnhan = false;
			if (res == undefined || res == null || !res.isChange)
				return;
			this.tmpChiTietKDDatHang = [];
			this.tmpChiTietKDDatHangf = [];
			this.reloadForm();
			if (this.listConfirmSelected.length > 0) {
				var dataUserValidate = this.listWaitingConfirmItem();
				var dataUserValidateIds = dataUserValidate.map(_x => _x.IdCt);
				this.listConfirmSelected = this.listConfirmSelected.filter(_x => dataUserValidateIds.indexOf(_x) > -1);
			}
			this.changeDetectView();
		});

	}
	IsConfirmAll() {
		let result = false;
		let tmpArray = [];
		if (this.vung_4) tmpArray = this.tmpChiTietKDDatHangf;
		if (this.vung_5) tmpArray = this.tmpChiTietKDDatHang;
		if (tmpArray.length > 0) {
			for (var i = 0; i < tmpArray.length; i++) {
				if (tmpArray[i].isDongYYCGH == false) result = true;
				else {
					result = false;
					break;
				}
			}
		}
		return result;
	}
	confirmAll() {
		this.KDDatHangService.xacNhanThongTinAll(this.KDDatHangItem.IdDH).subscribe(res => {
			if (res && res.status == 1) {
				this.tmpChiTietKDDatHang.forEach(item => {
					if (item.ListDetailGiaoHang.length > 0) {
						item.ListDetailGiaoHang.forEach(x => {
							x.TrangThai_Code = "KDXNKH_XACNHAN";
							x.TrangThai_Desc = "Đã xác nhận";
						})
						item.ListDetailGiaoHang = [...item.ListDetailGiaoHang];
					}
				})
				this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
				this.lichSuThaoTac(this.KDDatHangItem.IdDH, this.KDDatHangItem.Type);
				this.changeDetectView();
			}
		})
	}

	checkAnHienButtonXacNhan() {
		let flag = false;
		let LoaiPhieu = +this.FormPhieu.controls['LOAIPHIEU'].value;
		if (LoaiPhieu == 0) {
			this.tmpChiTietKDDatHang.forEach(e => {
				if (!e.isDongYYCGH && !e.isHoanTatKHGHMoi) flag = true;
			});
		}
		else {
			this.tmpChiTietKDDatHangf.forEach(e => {
				if (!e.isDongYYCGH && !e.isHoanTatKHGHMoi) flag = true;
			});
		}
		return flag;
	}
	checklistct() {
		let LoaiPhieu = +this.FormPhieu.controls['LOAIPHIEU'].value;
		if (LoaiPhieu == 0) {
			return this.tmpChiTietKDDatHang.length == 0
		}
		else {
			return this.tmpChiTietKDDatHangf.length == 0
		}
	}
	ListKH() {
		const NO_RELOAD_DETAILS = false;
		this.dungChung.listKH().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListKH = res.data;
				this.filteredListKH.next(this.listListKH.slice());
				if (this.them_moi || this.chinh_sua)
					this.selectedMaKH(this.KDDatHangItem.IdKH, NO_RELOAD_DETAILS);
				this.changeDetectView();
			};
		});
	}
	filterListKH() {
		if (!this.listListKH) {
			return;
		}
		// get the search keyword
		let search = this.ListKHFilterCtrl;
		if (!search) {
			this.filteredListKH.next(this.listListKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListKH.next(
			this.listListKH.filter(ts => ts.MaKH.toLowerCase().indexOf(search) > -1 || ts.TenKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	closeDropdownEvent(dropdownName: string) {
		if (dropdownName == 'MaKH') {
			//setTimeout(() => this.focusMaNCC.first.close(), 0);
			this.changeDetectView();
		}
		this.changeDetectView();
	}
	thongtinkk = '';
	selectedMaKH(value, refreshDetail: boolean = true) {
		if (value) {
			let index = this.listListKH.findIndex(x => x.Id_KH == Number(value));
			if (index > -1) {
				this.FormPhieu.controls['MAKH'].setValue(value.toString());
				this.FormPhieu.controls['TENKH'].setValue(this.listListKH[index].TenKH);
				this.thongtinkk = this.listListKH[index].MaKH + ' - ' + this.listListKH[index].TenKH;
				var addressSelected = this.listListKH[index].DiaChiGiaoHangs;
				this.listAdressOfCustomerSelected = addressSelected ? addressSelected : [];
			}
			if (refreshDetail) {
				this.tmpChiTietKDDatHang = [];
				this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
			}
		}
		this.changeDetectView();
	}
	ChangeThue(event: any, item: any) {
		var data = this.tmpChiTietKDDatHang;
		var vat = this.customNumberFormat(event.target.value);
		var index = data.indexOf(item);
		data[index].PhanTramThueVAT = vat;
		data[index].TienThueVAT = vat * data[index].ThanhTienQuyDoi / 100;
	}
	ChangeSL(event: any, index: number, field: string = "") {
		var vat = this.customNumberFormat(event.target.value, field);
		if (field != "")
			this.tmpChiTietKDDatHangf[index][field] = vat;
		else
			this.tmpChiTietKDDatHangf[index].KhoiLuong = vat;
		this.changeDetectView();
	}
	checkDateNull(event, col) {
		if (!event.target.value) {
			this.FormThemTungMH.controls[col].setValue(new Date());
			this.changeDetectView();
		}
	}
	ChangePhanTramThue(item: KDDatHangChiTiet) {
		let i = this.tmpChiTietKDDatHang.findIndex(x => x.IdHH == item.IdHH);
		this.tmpChiTietKDDatHang[i].PhanTramThueVAT = Number(item.PhanTramThueVAT);
		this.tmpChiTietKDDatHang[i].TienThueVAT = item.PhanTramThueVAT * this.tmpChiTietKDDatHang[i].ThanhTienQuyDoi / 100;
		this.changeDetectView();
	}
	changeNgayGiaoHang(item: any, index: number = -1, field: string) {
		if (moment(this.tmpChiTietKDDatHangf[index].NgayGiaoHangTu).format('YYYY-MM-DD') > moment(this.tmpChiTietKDDatHangf[index].NgayGiaoHangDen).format('YYYY-MM-DD')) {
			this.layoutUtilsService.showErorr("Ngày yêu cầu có hàng không hợp lệ");
			this.tmpChiTietKDDatHangf[index].NgayGiaoHangDen = this.tmpChiTietKDDatHangf[index].NgayGiaoHangTu = moment(new Date()).format('YYYY-MM-DD');
			return
		}
		this.tmpChiTietKDDatHangf[index][field] = moment(this.tmpChiTietKDDatHangf[index][field]).format('YYYY-MM-DD');

		if (this.tmpChiTietKDDatHangf[index].NgayGiaoHangTu != null && this.tmpChiTietKDDatHangf[index].NgayGiaoHangDen != null) {
			let overlappingIndex = this.findOverlappingForecastIndex(this.tmpChiTietKDDatHangf[index], index);
			if (overlappingIndex != -1) {
				this.updateExistingOrderDetail(overlappingIndex, this.tmpChiTietKDDatHangf[index]);
				this.tmpChiTietKDDatHangf = this.tmpChiTietKDDatHangf
					.filter((d, i) => i != index);
			}
		}

		this.changeDetectView();
	}
	updateThanhTienQuyDoi() {
		let tygia = this.customNumberFormat(this.FormPhieu.controls['TYGIA'].value.toString());
		// if(!tygia){
		// 	tygia = 1;
		// 	this.FormLoaiTien.controls['TYGIA'].setValue(this.f_currency_VND(this.formatNumber('1')));
		// }
		this.tmpChiTietKDDatHang.forEach(x => {
			x.ThanhTienQuyDoi = x.KhoiLuong * x.DonGia * tygia;
			x.TienThueVAT = x.PhanTramThueVAT * x.ThanhTienQuyDoi / 100;
		});
		this.refreshList();
	}
	updateMoney() {
		let money = 0;
		let thue = 0;
		this.tmpChiTietKDDatHang.forEach(x => {
			money += x.ThanhTienQuyDoi;
			thue += x.TienThueVAT;
		});
		let sumMoney = money + ((thue) ? Number(thue) : 0);
		this.FormTongTien.controls['TONGTIENCHUATHUE'].setValue(this.f_currency_VND(this.formatNumber(money.toString())));
		this.FormTongTien.controls['THUE'].setValue(this.f_currency_VND(this.formatNumber(thue.toString())));
		this.FormTongTien.controls['TONGTIEN'].setValue(this.f_currency_VND(this.formatNumber(sumMoney.toString())));
		this.changeDetectView();
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.customNumberFormat(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

			} else {
				event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
			}
		}
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	ChangeNumber(event, min: number = 0) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (event.target.value) {
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));

			}
			if (('' + tmpValue).indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			event.target.value = tmpValue == "" ? null : this.f_currency_VND(this.formatNumber(tmpValue));
		}
		else {
			event.target.value = min == null ? null : this.f_currency_VND(this.formatNumber(min.toString()));
		}
	}
	changeInputCurrency(event, columnName, formGroup) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				formGroup.controls[columnName].setValue(data);
				this.updateThanhTienQuyDoi();
				this.updateMoney();
				this.changeDetectView();
			}
		}
	}
	checkPositiveNumbers(event) {
		FunctionPublic.checkPositiveNumbers(event);
	}
	keyUpInputNumber(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	customNumberFormat(number: string, columnName: string = '') {
		const IsQuantityToBeConfirmedColumn = columnName == 'QuantityToBeConfirmed';
		if (number == null || number == undefined || number == "") {
			if (IsQuantityToBeConfirmedColumn)
				return null;
			return 0;
		}
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}


	originalChangeForecast = [];
	masterToggle(event) {
		// if (event.checked) {
		// 	this.originalTimKiemNangCaoResult = [];
		// 	this.tmpChiTietKDDatHangf.forEach(element => {
		// 		let tmp: any;
		// 		tmp = element;
		// 		this.originalTimKiemNangCaoResult.push(tmp)
		// 	});
		// } else {
		// 	this.originalTimKiemNangCaoResult = [];
		// }
		this.changeDetectView();
	}
	isAllSelected() {
		const numSelected = this.originalChangeForecast.length;
		const numRows = this.tmpChiTietKDDatHangf.length;
		return numSelected === numRows;
	}
	isChecked(item: any) {
		let _index = this.originalChangeForecast.findIndex(x => x.IdHH == item.IdHH);
		if (_index > -1)
			return true;
		return false;
	}
	addremove(event, row) {
		if (event.checked) {
			this.originalChangeForecast.push(row);
		} else {
			let index = this.originalChangeForecast.findIndex(x => x.IdHH == row.IdHH);
			if (index > -1) {
				this.originalChangeForecast.splice(index, 1);
			}
			this.originalChangeForecast = [...this.originalChangeForecast];
		}
		this.changeDetectView();
	}

	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case "KDXNKH_CHUAXACNHAN":
				return '_choxacnhan';
			default:
				return 'success';
		}
	}

	async getListForecast(item: KDDatHangChiTiet) {

		if (item.ThuocForecast) {
			let res = await this.KDDatHangService.fetchForecastByProductIdAndModel(item.IdHH, this.KDDatHangItem.BusinessModel).toPromise();
			item.ListForecast = res.data || [];
			item.filteredListForecast.next(item.ListForecast.slice());

			if (item.ForecastDetailId && item.ForecastDetailId > 0) {
				const emptyForecastId = item.ListForecast.findIndex(e => e.IdCt == item.ForecastDetailId) == -1;
				if (emptyForecastId) {
					item.ThuocForecast = false;
					item.Forecast_Id = null;
					item.ForecastDetailId = null;
					item.Forecast_SoPhieu = null;
				}
			}

			this.checkAllThuocForecast();
		} else {
			item.ListForecast = [];
			item.filteredListForecast.next(item.ListForecast.slice());
			item.ThuocForecast = false;
			item.Forecast_Id = null;
			item.Forecast_SoPhieu = null;
			item.ForecastDetailId = null;
		}
		this.changeDetectView();
	}
	filterForecast(item: KDDatHangChiTiet) {
		if (!item.ListForecast) { return; }
		let search = item.ForecastFilterCtrl;
		if (!search) {
			item.filteredListForecast.next(item.ListForecast.slice());
			return;
		}
		else { search = search.toLowerCase(); }
		item.filteredListForecast.next(
			item.ListForecast.filter(x => (x.SoPhieu ? x.SoPhieu.toLowerCase().indexOf(search) > -1 : false))
		);
		this.changeDetectView();
	}

	getSLTonKho(item: KDDatHangChiTiet) {
		return (
			`SL có PO: ${this.f_number(item.SLCoPO == null ? 0 : item.SLCoPO)} \n` +
			`SL tự do: ${this.f_number(item.SLTuDo == null ? 0 : item.SLTuDo)}`
		);
	}
	callDetail(idHH = 0, idCtDHB = 0) {
		this.dialog.open(BaoCaoChiTietDonHangBanDetailComponent, {
			data: {
				IdHH: idHH,
				IdCtDHB: idCtDHB,
			},
			height: '90vh',
			width: '90vw'
		});
	}


	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	// .. Kiểm tra thay đổi dữ liệu
	isChangeContextForm() {
		var diff = false;
		var formInit = this.FormPhieuInit;
		var formCurr = this.FormPhieu;
		var COLS_FORM = ["LOAIPHIEU", "MAKH", "DONVI", "TYGIA", "GHICHU"]
		var INDEX_NUMBER = [3];

		// .. Kiểm tra khác biệt form
		COLS_FORM.forEach((column, index) => {
			if ((INDEX_NUMBER.includes(index) && this.customNumberFormat(formInit.value[column]) != this.customNumberFormat(formCurr.value[column]))
				|| (!INDEX_NUMBER.includes(index) && formInit.value[column] != formCurr.value[column])) {
				diff = true;
			}
			if (diff) return;
		});

		// .. Kiểm tra dữ liệu danh sách
		if (!diff) {
			var listDetail = Number(formCurr.value[COLS_FORM[0]]) == 0 ? this.tmpChiTietKDDatHang : this.tmpChiTietKDDatHangf;
			diff = this.isChangeContextList(listDetail, formCurr, COLS_FORM);
		}
		return diff;
	}
	isChangeContextList(listDetail, form, optionalCol) {
		var diff = false;
		if (this.data.data.IdDH == 0 && listDetail.length > 0)
			diff = true;
		if (this.data.data.IdDH > 0) {
			listDetail.forEach(_x => {
				var item = this.KDDatHangItem.Cts.find(a => a.IdCt == _x.IdCt);
				if (!item) {
					diff = true;
					return;
				}
				// .. Kiểm tra cho đơn hàng khách hàng
				if (form.value[optionalCol[0]] == 0) {
					if (item.IdHH != _x.IdHH || item.KhoiLuong != _x.KhoiLuong
						|| moment(item.NgayGiaoHang).format("YYYY-MM-DD") != moment(_x.NgayGiaoHang).format("YYYY-MM-DD")
						|| item.PhanTramThueVAT != _x.PhanTramThueVAT
						|| item.GhiChu != _x.GhiChu
						|| item.ThuocForecast != _x.ThuocForecast
						|| item.Forecast_Id != _x.Forecast_Id) {
						diff = true;
						return;
					}
					// .. Kiểm tra extend details
					if (!diff && _x.ListDetailGiaoHang && _x.ListDetailGiaoHang.length > 0) {
						if (_x.ListDetailGiaoHang.length != item.ListDetailGiaoHang.length) {
							diff = true;
							return;
						}
						_x.ListDetailGiaoHang.forEach(detail => {
							var item2 = item.ListDetailGiaoHang.find(a => a["Id"] == detail.Id);
							if (!item2) {
								diff = true;
								return;
							}
							if (item2.KhoiLuong != detail.KhoiLuong
								|| moment(item2.NgayGiaoHang).format("YYYY-MM-DD") != moment(detail.NgayGiaoHang).format("YYYY-MM-DD")) {
								diff = true;
								return;
							}
						})
					}
				}
				// .. Kiểm tra cho đơn hàng forecast
				if (form.value[optionalCol[0]] == 1) {
					if (item.IdHH != _x.IdHH || item.KhoiLuong != _x.KhoiLuong
						|| moment(item.NgayGiaoHangTu).format("YYYY-MM-DD") != moment(_x.NgayGiaoHangTu).format("YYYY-MM-DD")
						|| moment(item.NgayGiaoHangDen).format("YYYY-MM-DD") != moment(_x.NgayGiaoHangDen).format("YYYY-MM-DD")) {
						diff = true;
						return;
					}
				}
			})
			if (listDetail.length == 0)
				diff = true;
		}
		return diff;
	}

	// .. Reload Form Detail
	async reloadForm() {
		const ID = this.data.data.IdDH;
		const TYPE_1 = 1;
		const TYPE_0 = 0;
		const FORM = this.FormPhieu.controls;
		var res = await this.KDDatHangService.detailOrder(ID).toPromise();
		if (!res || res.status == 0) {
			this.layoutUtilsService.showErorr("Lỗi lấy thông tin chi tiết phiếu");
			return;
		}
		this.KDDatHangItem = res.data;
		this.__LoaiPhieu = this.KDDatHangItem.Type == TYPE_1 ? TYPE_0 : TYPE_1;
		this.createForm();
		this.anHienTheoThaoTac();
		this.lichSuThaoTac(ID, FORM['LOAIPHIEU'].value);
		this.changeDetectView();
	}

	// .. Set cell style
	getCellStyles(item: any) {
		return {
			'm--padding-10': true,
			'background-color': item.isError ? '#ff000038' : null
		};
	}
	// .. Set input style
	getInputStyles(item: any, col: string) {
		const isDiaChiGiaoHang = col === 'DiaChiGiaoHang';
		const hasNoDetailAndData = item[col] && (!item.ListDetailGiaoHang || item.ListDetailGiaoHang.length === 0);
		const hasNoDetailAndNoData = !item[col] && (!item.ListDetailGiaoHang || item.ListDetailGiaoHang.length === 0);
		return {
			'mat-form-field-fluid': true,
			'border-underline': (isDiaChiGiaoHang ? hasNoDetailAndData : item[col]) && !item.isError,
			'border-underline-error': (isDiaChiGiaoHang ? hasNoDetailAndNoData : !item[col]) || item.isError
		};
	}
	// .. Format date
	customDateFormat(date) {
		return moment(date).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
	}

	// .. Thêm file bằng chứng
	selectFile() {
		this.fileUpload1.nativeElement.click();
	}
	onChangeFileSelected(evt: any) {
		const files = evt.target.files;
		const form = this.PriceEvidenceFilesForm.controls;
		const _ref = this.priceEvidenceFilesTmp;
		const _this = this;

		if (files && files.length) {
			for (var i = 0; i < files.length; i++) {
				const file = files[i];
				const fileName = file.name;
				const el: any = this.fileUpload1.nativeElement;
				const reader = new FileReader();

				form["FILENAME"].setValue(fileName);
				reader.readAsDataURL(el.files[i]);
				reader.onload = function () {
					const base64Str = reader.result as string;
					const metaIdx = base64Str.indexOf(";base64,");
					const data = new FileImport();
					data.filename = fileName;
					data.base64 = base64Str.substr(metaIdx + 8);
					data.extension = fileName.split(".").pop();
					data.fileByte = file;
					data.dienGiai = _this.convertKBToOtherUnits(file.size / 1024);
					_ref.push(data);
				};
			}
		}
		evt.target.type = "text";
		evt.target.type = "file";
		this.changeDetectView();
	}
	addPriceEvidenceFiles(formGroup: any) {
		const _ref = this.priceEvidenceFilesTmp;
		if (_ref != null) {
			const names = _ref.map(a => a.filename);
			const files = this.priceEvidenceFiles.filter((x) => names.includes(x.filename)).map(x => x.filename);
			const lenFile = files.length;
			if (lenFile > 0) {
				const warnMessage = "File " + files.join(",") + " đính kèm đã tồn tại. Tiếp tục thêm?";
				const dialogRef = this.layoutUtilsService.POPConfirm(warnMessage);
				dialogRef.afterClosed().subscribe((res) => {
					if (!res) {
						formGroup.reset();
						return;
					}
					this.priceEvidenceFiles = [...this.priceEvidenceFiles, ..._ref];
					this.priceEvidenceFiles = [...this.priceEvidenceFiles];
					formGroup.reset();
					this.priceEvidenceFilesTmp = [];
				});
			} else {
				this.priceEvidenceFiles = [...this.priceEvidenceFiles, ..._ref];
				this.priceEvidenceFiles = [...this.priceEvidenceFiles];
				formGroup.reset();
				this.priceEvidenceFilesTmp = [];
			}
		}
	}
	removePriceEvidenceFiles(i: number) {
		const warnMessage = "Bạn có chắc chắn muốn xóa file?";
		const dialogRef = this.layoutUtilsService.POPConfirm(warnMessage);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			this.priceEvidenceFiles.splice(i, 1);
			this.priceEvidenceFiles = [...this.priceEvidenceFiles];
			this.changeDetectView();
		});
	}
	convertKBToOtherUnits(kilobytes) {
		const bytesInKB = 1024;
		const bytesInMB = bytesInKB * 1024;
		const bytesInGB = bytesInMB * 1024;
		const bytesInTB = bytesInGB * 1024;

		if (kilobytes < bytesInKB) {
			return kilobytes.toFixed(2) + ' KB';
		} else if (kilobytes < bytesInMB) {
			return (kilobytes / bytesInKB).toFixed(2) + ' MB';
		} else if (kilobytes < bytesInGB) {
			return (kilobytes / bytesInMB).toFixed(2) + ' GB';
		} else if (kilobytes < bytesInTB) {
			return (kilobytes / bytesInGB).toFixed(2) + ' TB';
		} else {
			return (kilobytes / bytesInTB).toFixed(2) + ' TB';
		}
	}
	downloadPriceEvidenceFiles(item: FileImport) {
		const _ref = this.KDDatHangService;
		const id = item.idLoaiHH;
		if (id > 0) {
			_ref.downloadPriceEvidenceFiles(id).subscribe((blob) => {
				this.processPriceEvidenceFiles(blob, item.filename);
			})
		} else {
			this.processPriceEvidenceFiles(item.fileByte, item.filename);
		}
	}
	processPriceEvidenceFiles(file, filename) {
		var link = document.createElement("a");
		link.href = URL.createObjectURL(file);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	isInvalidDate(x, type, typeConst) {
		if (type === typeConst) {
			return !x.NgayGiaoHang || x.NgayGiaoHang === 'Invalid date';
		} else {
			return !x.NgayGiaoHangTu || x.NgayGiaoHangTu === 'Invalid date' || !x.NgayGiaoHangDen || x.NgayGiaoHangDen === 'Invalid date';
		}
	}
	saveCustomerPurchaseOrder() {
		const _ref = this.KDDatHangService;
		const data = {
			Id: this.KDDatHangItem.IdDH,
			NewCustomerPurchaseOrder: this.FormPhieu.controls['CUSTOMER_PURECHASE_ORDER'].value
		}
		_ref.saveCustomerPurchaseOrder(data).subscribe(res => {
			if (res.status == 1) {
				this.layoutUtilsService.showInfo("Lưu thông tin PO khách hàng thành công");
			} else {
				this.layoutUtilsService.showErorr("Lưu thông tin PO khách hàng thất bại");
			}
		})
	}
	// Hàm xử lý checked mỗi chi tiết
	toggleConfirmItem(event, rowID: number) {
		const isChecked = event.checked;

		// Nếu rowID không tồn tại thì return
		if (!rowID) return;

		// Nếu isChecked = true thì cần thêm rowID vào listConfirmSelected và ngược lại
		if (isChecked) {
			this.listConfirmSelected = [...this.listConfirmSelected, rowID];
		} else {
			this.listConfirmSelected = this.listConfirmSelected.filter(_x => _x != rowID);
		}

		this.changeDetectView();
	}

	// Kiểm tra rowID có được thêm vào mảng chưa
	selecedConfirmItem(rowID: number) {
		return this.listConfirmSelected.findIndex(x => x == rowID) > -1;
	}

	// Hàm xử lý chọn/bỏ chọn tất cả chi tiết
	toggleConfirmAllItem(event) {
		const isChecked = event.checked;
		const listWaitingConfirmItem = this.listWaitingConfirmItem();
		this.listConfirmSelected = [];

		// Nếu isChecked là true là chọn tất cả
		if (isChecked) {
			const detailIDs = listWaitingConfirmItem.map(_x => _x.IdCt);
			this.listConfirmSelected = [...detailIDs];
		}

		this.changeDetectView();
	}

	// Kiểm tra đã chọn hết tất cả chi tiết chưa
	selectedConfirmAllItem() {
		const listWaitingConfirmItem = this.listWaitingConfirmItem();
		const detailItemAmount = listWaitingConfirmItem.length;
		const detailSelectedAmount = this.listConfirmSelected.length;
		return detailItemAmount == detailSelectedAmount && detailItemAmount > 0;
	}

	// Kiểm tra list xác nhận đã thêm bất kì chi tiết nào chưa
	selectedAnyConfirmItem() {
		const detailSelectedAmount = this.listConfirmSelected.length;
		return !this.selectedConfirmAllItem() && detailSelectedAmount > 0;
	}

	// Disable những chi tiết đã đồng ý yêu cầu giao hàng
	disableConfirmItem(row: KDDatHangChiTiet) {
		return row.isDongYYCGH || !row.CanConfirmDetails;
	}

	// Disabled nút chọn tất cả nếu tất cả đã đồng ý yêu cầu giao hàng
	disableConfirmAllItem() {
		const listWaitingConfirmItem = this.listWaitingConfirmItem();
		return listWaitingConfirmItem.length == 0;
	}

	// Lấy tất cả chi tiết chưa được Đồng ý yêu cầu giao hàng
	listWaitingConfirmItem() {
		const flagPurchaseOrder = this.KDDatHangItem.Type == Number(ConstantPurchaseOrder.OPTION_PURCHASEORDER);
		const source = flagPurchaseOrder ? this.tmpChiTietKDDatHang : this.tmpChiTietKDDatHangf;

		return source.filter(_x => !_x.isDongYYCGH && _x.CanConfirmDetails);
	}

	// Set data thông tin xác nhận Đồng ý yêu cầu giao hàng
	setPOConfirmMultipleDetails() {
		var listPOConfirmMultiple = [];
		const MESSAGE_SUCCESS = "Xác nhận cho các chi tiết của đơn hàng đã chọn thành công!";
		const requestConfirmMultiple = this.listConfirmSelected;
		const flagPurchaseOrder = this.KDDatHangItem.Type == Number(ConstantPurchaseOrder.OPTION_PURCHASEORDER);
		const masterData = flagPurchaseOrder ? this.tmpChiTietKDDatHang : this.tmpChiTietKDDatHangf;

		// Lọc các bản ghi cần xác nhận từ masterData
		const requestConfirmMultipleInfo = masterData.filter(record =>
			requestConfirmMultiple.indexOf(record.IdCt) > -1
		);
		// Lọc các bản ghi có thể xác nhận chi tiết
		const parentInfo = requestConfirmMultipleInfo.filter(record =>
			record.CanConfirmDetails
		);

		// Chạy lần lượt các chi tiết và list giao hàng
		parentInfo.forEach(parent => {
			if (flagPurchaseOrder) {
				parent.ListDetailGiaoHang.forEach(child => {
					const canConfrimDetail = !child.isDongYYCGH && child.CanActionConfirm;
					if (canConfrimDetail) {
						const detailConfirm = new ThongTinXacNhanCTModel();
						detailConfirm.clear();
						detailConfirm.Id = child.Id;
						detailConfirm.IdCt = child.IdCt;
						detailConfirm.IdDH = parent.IdDH;
						detailConfirm.SLGiao = Number(child.KhoiLuong);
						detailConfirm.NgayGiao = null;
						detailConfirm.NgayYCGiao = null;
						detailConfirm.NgayYCGiaoMoi = null;
						detailConfirm.TrangThai = ConstantPurchaseOrder.ACTION_DONGYYCGH;
						listPOConfirmMultiple.push(detailConfirm);
					}
				})
			} else {
				const detailConfirm = new ThongTinXacNhanCTModel();
				detailConfirm.IdDH = parent.IdDH;
				detailConfirm.IdCt = parent.IdCt;
				detailConfirm.SLGiao = Number(parent.KhoiLuong);
				detailConfirm.NgayGiao = moment(parent.NgayGiaoHangTu).format("YYYY-MM-DD").toString();
				const confirmPlan = new ThongTinXacNhanModel();
				confirmPlan.clear();
				confirmPlan.IdDH = parent.IdDH;
				confirmPlan.IdCt = parent.IdCt;
				confirmPlan.TrangThai = 'KDDH_DONGYYCGH';
				confirmPlan.CTs = [detailConfirm];
				listPOConfirmMultiple.push(confirmPlan);
			}
		})

		// Bắt buộc xác nhận, nếu đồng ý gửi thông tin đến api
		const dialogRef = this.layoutUtilsService.POP02_DanhMuc();
		dialogRef.afterClosed().subscribe(res => {
			if (!res) return;
			if (flagPurchaseOrder) {
				this.KDDatHangService.xacNhanThongTinInsert(listPOConfirmMultiple).subscribe(
					res => {
						if (res && res.status === 1) {
							this.listConfirmSelected = [];
							this.layoutUtilsService.showInfo(MESSAGE_SUCCESS);
							this.tmpChiTietKDDatHang = [];
							this.tmpChiTietKDDatHangf = [];
							this.reloadForm();
							this.changeDetectView();
						} else {
							this.layoutUtilsService.showErorr(res.error.message);
						}
					})
			} else {
				this.KDDatHangService.xacNhanThongTinInsertFC(listPOConfirmMultiple).subscribe(
					res => {
						if (res && res.status === 1) {
							this.listConfirmSelected = [];
							this.layoutUtilsService.showInfo(MESSAGE_SUCCESS);
							this.tmpChiTietKDDatHang = [];
							this.tmpChiTietKDDatHangf = [];
							this.reloadForm();
							this.changeDetectView();
						} else {
							this.layoutUtilsService.showErorr(res.error.message);
						}
					})
			}
		});
	}

	// Đóng phiếu Forecast về hoàn tất
	setCloseForecast() {
		this.donHangBanService.setCloseForecast(this.KDDatHangItem.IdDH).subscribe(response => {
			if (response && response.status == this.CONFIG.RESPONSE_SUCCESS) {
				this.FormPhieu.controls["TRANGTHAI"].setValue(response.data);
				this.KDDatHangItem.IsCloseForecast = false;
				this.isChange = true;
				this.saveAddedTTHV = [this.KDDatHangItem.IdDH];
				this.layoutUtilsService.showInfo(`Forecast ${this.KDDatHangItem.SoPhieu} đã đóng.`);
			} else {
				this.layoutUtilsService.showErorr(`Thao tác đóng forecast ${this.KDDatHangItem.SoPhieu} xảy ra lỗi.`);
			}
			this.changeDetectView();
		})
	}

	// Lấy thông tin form là Đơn đặt hàng hay không
	isPurchaseOrderForm() {
		const form = this.FormPhieu;
		if (!form) return false;
		return form.controls['LOAIPHIEU'].value == ConstantPurchaseOrder.OPTION_PURCHASEORDER;
	}

	// Lấy thông tin form là Forecast hay không
	isForecastForm() {
		const form = this.FormPhieu;
		if (!form) return false;
		return form.controls['LOAIPHIEU'].value == ConstantPurchaseOrder.OPTION_FORECAST;
	}

	// Lấy thông tin B2B
	isForecastB2B() {
		return this.isForecastForm() && this.data.model == ConstantPurchaseOrder.CODE_B2B;
	}

	// Lấy thông tin B2B
	isForecastB2C() {
		return this.isForecastForm() && this.data.model == ConstantPurchaseOrder.CODE_B2C;
	}

	// Check phiếu là PO B2C
	isPurchaseOrderB2C() {
		return this.isPurchaseOrderForm() && this.data.model == ConstantPurchaseOrder.CODE_B2C;
	}

	// Function to check if a control exists in the FormGroup
	checkControlExists(controlName: string): boolean {
		if (!this.FormPhieu) return false;
		return !!this.FormPhieu.controls[controlName];
	}

	// Get list data of Category Channel
	getListChannel() {
		this.categoryChannelService.listDropdown().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listChannel = res.data;
				this.filteredListChannel.next(this.listChannel.slice());
				this.changeDetectView();
			};
		});
	}

	filterListChannel() {
		let search = this.ListChannelFilterCtrl;
		if (!this.listChannel) return;
		if (!search) {
			this.filteredListChannel.next(this.listChannel.slice());
			return;
		}
		search = search.toLowerCase().trim();
		const listAppliedFilter = this.listChannel.filter(ts => ts.kenhsan.toLowerCase().indexOf(search) > -1);
		this.filteredListChannel.next(listAppliedFilter);
		this.changeDetectView();
	}

	extendPOOfCustomerColumnInList() {
		const previousLastParentColumnPosition = this.availableColumns.length - 1;
		const isPurchaseOrder = this.KDDatHangItem.Type.toString() == ConstantPurchaseOrder.OPTION_PURCHASEORDER;
		const purchaseOrderCustomer = {
			stt: 99,
			name: 'POCUSTOMERDETAIL',
			displayName: 'PO Khách hàng',
			alwaysChecked: true,
			isShow: true
		};

		if (isPurchaseOrder && this.isModelB2C) {
			this.availableColumns.splice(previousLastParentColumnPosition, 0, purchaseOrderCustomer);
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		}
	}

	duplicateItem(item: KDDatHangChiTiet) {
		let duplicate = new KDDatHangChiTiet();
		duplicate.clear();
		duplicate.copy(item);
		duplicate.IdCt = 0;
		duplicate.IdDH = 0;

		this.tmpChiTietKDDatHang.push(duplicate);
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.changeDetectView();
	}

	findNextState(isAccept: boolean = false, currentState: string) {
		const REJECT_BY_PLANNING_EMPLOYEE = this.TinhTrang[12].Code;
		const REJECT_BY_MANAGER = this.TinhTrang[2].Code;
		const WAIT_TO_PLANNING_EMPLOYEE = this.TinhTrang[11].Code;
		const WAIT_TO_SALE_DIRECTOR = this.TinhTrang[3].Code;
		const WAIT_TO_MANAGER = this.TinhTrang[1].Code;
		const PROCESSING = this.TinhTrang[10].Code;

		if (isAccept) {
			if (currentState == WAIT_TO_MANAGER) {
				return this.isForecastForm() ? WAIT_TO_PLANNING_EMPLOYEE : WAIT_TO_SALE_DIRECTOR;
			} else if (currentState == WAIT_TO_PLANNING_EMPLOYEE) {
				return this.isForecastB2B() ? PROCESSING : WAIT_TO_SALE_DIRECTOR;
			} else {
				return "";
			}
		} else {
			if (currentState == WAIT_TO_MANAGER) {
				return REJECT_BY_MANAGER;
			} else if (currentState == WAIT_TO_PLANNING_EMPLOYEE) {
				return REJECT_BY_PLANNING_EMPLOYEE;
			} else {
				return "";
			}
		}
	}

	extendColumnIfChangeForecast() {
		const QUANTITY_COLUMN = 'SL';
		const QUANTITY_DELIVERED_COLUMN = 'SOLUONGDAGIAO';
		const IS_FORECAST = this.KDDatHangItem.Type.toString() === ConstantPurchaseOrder.OPTION_FORECAST;

		if (!IS_FORECAST) { return; }

		let quantityColumnPosition = this.availableColumns.findIndex(col => col.name === QUANTITY_COLUMN) - 1;
		let quantityDeliveredColumnPosition = this.availableColumns.findIndex(col => col.name === QUANTITY_DELIVERED_COLUMN) - 1;
		if (this.thay_doi_forecast || this.KDDatHangItem.IsHistoriesChangeForecast) {
			this.availableColumnsf.splice(quantityColumnPosition, 1);
			ConstantPurchaseOrder.EXTEND_FORECAST_COLUMNS.forEach(col => {
				this.availableColumnsf.splice(quantityColumnPosition, 0, col);
			});
			quantityDeliveredColumnPosition += ConstantPurchaseOrder.EXTEND_FORECAST_COLUMNS.length - 1;
		}
		this.availableColumnsf.splice(quantityDeliveredColumnPosition, 0, ...ConstantPurchaseOrder.REMAINING_QUANTITY_COLUMN);
		this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
	}
	getUtcMidnightDate() {
		return new Date(Date.UTC(
			new Date().getUTCFullYear(),
			new Date().getUTCMonth(),
			new Date().getUTCDate(),
			0, 0, 0, 0
		));
	}

	duplicateForecastDetail(item: KDDatHangChiTiet): void {
		let newForecastDetail = new KDDatHangChiTiet();
		newForecastDetail.clear();
		newForecastDetail.copy(item);
		newForecastDetail.IdCt = 0;
		newForecastDetail.NgayGiaoHangTu = null;
		newForecastDetail.NgayGiaoHangDen = null;

		this.tmpChiTietKDDatHangf.push(newForecastDetail);
		this.tmpChiTietKDDatHangf = [...this.tmpChiTietKDDatHangf];
		this.changeDetectView();
	}

	openInventoriesDetailModel(detail: any) {
		const dialogRef = this.dialog.open(
			ChiTietSoLuongTonPageComponent, {
			data: {
				IdHH: detail.IdHH,
				Ma_Ten_HH: `${detail.MaHH} - ${detail.TenHH}`,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			setTimeout(() => { }, 500);
		});
	}

	async updateTempCustomer(item) {
		try {
			const res = await this.dungChung.layDanhSachKhachHang().toPromise();
			const res2 = await this.dungChung.listLoaiKH().toPromise();
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				const dialogRef = this.dialog.open(ForecastUpdateModelComponent, {
					data: {
						content: "khách hàng",
						list: res.data || [],
						forecastId: this.KDDatHangItem.IdDH,
						id: "IdKh",
						code: "Makh",
						name: "Tenkh",
						target: "customer",
						element: { id: item.IdKH, code: item.MaKH, name: item.TenKH, type: item.TempCustomerType, typeId: item.CustomerTypeId },
						list2: res2.data || []
					},
					width: "40%",
				});

				dialogRef.afterClosed().subscribe(res => {
					if (!res) { return; }
					this.KDDatHangItem.IdKH = res.id;
					this.KDDatHangItem.MaKH = res.code;
					this.KDDatHangItem.TenKH = res.name;
					this.KDDatHangItem.CustomerTypeId = res.typeId;
					this.FormPhieu.controls['MAKH'].setValue(res.code);
					this.FormPhieu.controls['TENKH'].setValue(res.name);
					this.changeDetectView();
				});
			}
			else {
				this.layoutUtilsService.showErorr("Lỗi tải danh sách khách hàng");
			}
		} catch (error) {
			this.layoutUtilsService.showErorr("Lỗi tải danh sách khách hàng");
		}
	}

	async updateTempProduct(item, index) {
		let res = await this.KDDatHangService.ListHH().toPromise();
		if (res && res.status == 1) {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				const dialogRef = this.dialog.open(ForecastUpdateModelComponent, {
					data: {
						content: "hàng hoá",
						list: res.data || [],
						forecastId: item.IdCt,
						id: "IdHH",
						code: "MaHH",
						name: "TenHH",
						target: "product",
						element: { id: item.IdHH, code: item.MaHH, name: item.TenHH, type: "", typeId: null },
						list2: []
					},
					width: "40%",
				});

				dialogRef.afterClosed().subscribe(res => {
					if (!res) { return; }
					this.tmpChiTietKDDatHangf[index].IdHH = res.id;
					this.tmpChiTietKDDatHangf[index].MaHH = res.code;
					this.tmpChiTietKDDatHangf[index].TenHH = res.name;
					this.changeDetectView();
				});
			} else {
				this.layoutUtilsService.showErorr("Lỗi tải danh sách hàng hoá");
			}
		}
	}

	setBranchAddress(event, item: KDDatHangChiTiet) {
		item.DiaChiGiaoHang = this.getBranchAddressById(event);
	}

	getBranchAddressById(branchId: number) {
		if (this.listAdressOfCustomerSelected.length == 0 || !branchId)
			return "";

		const selectedBranch = this.listAdressOfCustomerSelected.find(d => d.branchId == branchId);
		return selectedBranch ? selectedBranch.branchAddress : "";
	}

	isDateRequiredInvalid(option: any, item: any) {
		const { NgayGiaoHang } = item;
		const { DateRequestFrom, DateRequestTo } = option;

		if (NgayGiaoHang && DateRequestFrom && DateRequestTo) {
			const ngayGiao = new Date(NgayGiaoHang);
			ngayGiao.setHours(0, 0, 0, 0);

			const dateFrom = new Date(DateRequestFrom);
			dateFrom.setHours(0, 0, 0, 0);

			const dateTo = new Date(DateRequestTo);
			dateTo.setHours(23, 59, 59, 99);

			return !(ngayGiao >= dateFrom && ngayGiao <= dateTo);
		}
		return true;
	}

	setForecastIdByDetailId(item: KDDatHangChiTiet) {
		const { ForecastDetailId, ListForecast } = item;

		if (ForecastDetailId) {
			const option = ListForecast.find(d => d.IdCt == ForecastDetailId);
			item.Forecast_Id = option ? option.IdDH : null;
		}
	}

	disableOptionForecast(item: KDDatHangChiTiet, option: any): boolean {
		const { DateRequestFrom, DateRequestTo } = option;
		const { NgayGiaoHang } = item;

		if (NgayGiaoHang && DateRequestFrom && DateRequestTo) {
			const ngayGiao = new Date(NgayGiaoHang);
			ngayGiao.setHours(0, 0, 0, 0);

			const dateFrom = new Date(DateRequestFrom);
			dateFrom.setHours(0, 0, 0, 0);

			const dateTo = new Date(DateRequestTo);
			dateTo.setHours(23, 59, 59, 99);

			return ngayGiao < dateFrom || ngayGiao > dateTo;
		}

		return false;
	}

  atLeastOneItemCanUpdateForForecast() {
    return this.tmpChiTietKDDatHang.some(item => item.CanUpdateForForecast);
  }

  updateForForecast() {
    const itemsWithoutForecastDetail = this.tmpChiTietKDDatHang.filter(item => item.ThuocForecast && !item.ForecastDetailId);
    if (itemsWithoutForecastDetail.length > 0) {
      this.layoutUtilsService.showErorr("Có mặt hàng đã chọn thuộc forecast nhưng chưa chọn Forecast. Vui lòng kiểm tra lại.");
      return;
    }

    var updateForForecastBody = this.tmpChiTietKDDatHang.map(item => {
      return {
        orderId: item.IdDH,
        orderDetailId: item.IdCt,
        forForcastlId: item.Forecast_Id,
        forForcastDetailId: item.ForecastDetailId
      }
    });

    this.KDDatHangService.updateForForecast(updateForForecastBody).subscribe({
      next: (res) => {
        if (res && res.status == 1) {
          this.layoutUtilsService.showInfo("Cập nhật thuộc forecast thành công");
        } else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (err) => {
        this.layoutUtilsService.showErorr(err.message);
      },
      complete: () => {
        this.changeDetectView();
      }
    });
  }
}
